export default {
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    ok: 'موافق',
    copied: 'تم النسخ',
    selectAllLabel: 'تحديد الكل',
    submit: 'إرسال',
    logout: 'تسجيل الخروج',
    skip: 'تخطي',
    viewMore: 'عرض المزيد',
    viewLess: 'عرض أقل',
    changeLanguage: 'تغيير اللغة',
    areYouSure: 'هل أنت متأكد؟',
    done: 'تم',
    error: 'خطأ',
    close: 'إغلاق',
    noResultsFound: 'لا توجد نتائج',
    typeToSearch: 'الرجاء كتابة شيء للبحث!',
    typeToSearchPlaceholder: 'اكتب للبحث',
    active: 'نشط',
    edit: 'تعديل',
    updatedSuccessfully: 'تم التحديث بنجاح',
    success: 'نجاح',
    addedSuccessfully: 'تمت الإضافة بنجاح',
    date: 'التاريخ',
    user: 'المستخدم',
    new: 'جديد',
    delete: 'حذف',
    cash: 'نقداً',
    deletedSuccessfully: 'تم الحذف بنجاح',
    back: 'رجوع',
    inactive: 'غير نشط',
    all: 'الكل',
    add: 'إضافة',
    create: 'إنشاء',
    update: 'تحديث',
    reset: 'إعادة تعيين',
    editQuestion: 'تعديل؟',
    search: 'بحث',
    select: 'اختر',
    filterColon: 'تصفية:',
    showResultLabel: 'عرض',
    resultLabel: 'نتيجة',
    totalResultLabel: 'إجمالي النتائج {count}',
    selectedCountLabel: 'تم تحديد {count}',
    of: 'من',
    canceledStatus: 'ملغى',
    refundedStatus: 'مسترد',
    mobileSource: 'الموبايل',
    webSource: 'الموقع',
    adminSource: 'الإدارة',
    warning: 'تحذير',
    yes: 'نعم',
    no: 'لا',
    example: 'مثال: {value}'
  },
  columns: {
    id: 'المعرف',
    item: 'العنصر',
    itemCode: 'رمز الطلب',
    customer: 'العميل',
    name: 'الاسم',
    email: 'البريد الإلكتروني',
    phoneNumber: 'رقم الهاتف',
    itemName: 'اسم المنتج',
    brand: 'العلامة التجارية',
    url: 'الرابط',
    image: 'الصورة',
    dateTime: 'التاريخ والوقت',
    status: 'الحالة',
    statuses: 'الحالات',
    checkBoxColumn: 'خانة اختيار',
    warehouse: 'المستودع',
    branch: 'الفرع',
    role: 'الدور',
    summary: 'الملخص',
    shipping: 'الشحن',
    total: 'الإجمالي',
    qty: 'الكمية',
    size: 'الحجم',
    price: 'السعر',
    logo: 'الشعار',
    defaultImage: 'الصورة الافتراضية',
    country: 'الدولة',
    currency: 'العملة',
    prefix: 'البادئة',
    transportationTypes: 'أنواع النقل',
    city: 'المدينة',
    street: 'الشارع',
    code: 'الرمز',
    houseNumber: 'رقم المنزل',
    estimateDays: 'الأيام التقديرية',
    actions: 'الإجراءات',
    stateProvince: 'الولاية - المحافظة',
    flagCode: 'رمز العلم',
    customCode: 'الرمز المخصص',
    qr: 'رمز QR',
    customerId: 'رقم العميل',
    phone: 'الهاتف',
    headQuarter: 'المقر الرئيسي',
    type: 'النوع',
    purchaseNote: 'ملاحظة الشراء',
    bank: 'البنك',
    invoiceNo: 'رقم الفاتورة',
    orderId: 'رقم الطلب',
    productName: 'اسم المنتج',
    quantity: 'الكمية',
    note: 'ملاحظة',
    qrId: 'رقم QR',
    payment: 'الدفع',
    orderInfo: 'معلومات الطلب',
    itemDetails: 'تفاصيل المنتج',
    product: 'المنتج',
    statusLocation: 'الحالة والموقع',
    pricing: 'التسعير',
    datePayment: 'التاريخ والدفع',
    invoiceInfo: 'معلومات الفاتورة',
    shipmentCosts: 'تكاليف الشحن',
    cleared: 'تمت التسوية',
    purchaseDate: 'تاريخ الشراء',
    warehouseDate: 'تاريخ المستودع',
    bankName: 'اسم البنك',
    actualCost: 'التكلفة الفعلية',
    purchaseCost: 'تكلفة الشراء',
    totalAmount: 'المبلغ الإجمالي',
    purchasedBy: 'اشتراه',
    refundNumber: 'رقم الاسترداد',
    refundNote: 'ملاحظة الاسترداد',
    discount: 'الخصم',
    weight: 'الوزن',
    deliveryPrice: 'سعر التوصيل',
    nationalTax: 'الضريبة الوطنية',
    totalRefunded: 'إجمالي المسترد',
    refundStatus: 'حالة الاسترداد',
    trackNumber: 'رقم التتبع',
    orderNumber: 'رقم الطلب',
    createDate: 'تاريخ الإنشاء',
    caseId: 'رقم الحالة',
    caseOrderId: 'رقم الطلب',
    createdBy: 'أنشئ بواسطة',
    customerPhone: 'هاتف العميل',
    sentBy: 'أُرسل بواسطة',
    deadline: 'الموعد النهائي',
    attachedInvoices: 'الفواتير المرفقة',
    customerPhone2: 'هاتف العميل 2',
    defaultLocation: 'الموقع الافتراضي',
    totalPrice: 'السعر الإجمالي',
    orderHash: 'رقم الطلب #',
    volume: 'الحجم',
    handlingFee: 'رسوم المناولة',
    shipment: 'الشحنة',
    tax: 'الضريبة',
    amount: 'المبلغ',
    paidAmount: 'المبلغ المدفوع',
    remaining: 'المتبقي',
    outOffice: 'خارج المكتب',
    owner: 'المالك',
    receivedDate: 'تاريخ الاستلام',
    receivedAmount: 'المبلغ المستلم',
    createdAt: 'تاريخ الإنشاء',
    updatedAt: 'تاريخ التحديث',
    checkBox: 'مربع اختيار',
    deliveryAddress: 'عنوان التوصيل',
    generatedBy: 'أُنشئت بواسطة',
    dateFilterByLabel: 'فلترة التاريخ حسب',
    selectedSuffix: 'محدد',
    orderStatus: 'حالة الطلب',
    productUrl: 'رابط المنتج',
    transactionDate: 'تاريخ المعاملة',
    staffName: 'اسم الموظف',
    action: 'الإجراء',
    exRate: 'سعر الصرف',
    paymentMethod: 'طريقة الدفع',
    logDate: 'تاريخ السجل',
    cid: 'رقم العميل',
    subscription: 'الاشتراك',
    rateLog: 'سجل السعر',
    paidVia: 'الدفع عبر',
    title: 'العنوان',
    order: 'الترتيب',
    question: 'السؤال',
    answer: 'الجواب',
    coupon: 'الكوبون',
    expireDate: 'تاريخ الانتهاء',
    percentage: 'النسبة المئوية',
    nameArabic: 'الاسم (عربي)',
    nameKurdish: 'الاسم (كردي)',
    reasonEnglish: 'السبب (إنجليزي)',
    reasonArabic: 'السبب (عربي)',
    reasonKurdish: 'السبب (كردي)',
    shipzoneFee: 'رسوم شيب زون',
    handlingFeeAir: 'رسوم المناولة (جوي)',
    handlingFeeSea: 'رسوم المناولة (بحري)',
    itemPriceAir: 'سعر القطعة (جوي)',
    itemPriceSea: 'سعر القطعة (بحري)',
    itemPriceLand: 'سعر القطعة (بري)',
    localDelivery: 'التوصيل المحلي',
    default: 'افتراضي',
    netPrice: 'السعر الصافي',
    transportationType: 'نوع النقل',
    ordersStatus: 'حالة الطلبات',
    postalCode: 'الرمز البريدي',
    customerName: 'اسم العميل',
    customerNote: 'ملاحظة العميل',
    phoneNumber2: 'رقم الهاتف 2',
    governorate: 'المحافظة',
    address: 'العنوان',
    credit: 'الرصيد',
    shipOnly: 'شحن فقط',
    cancelReason: 'سبب الإلغاء',
    description: 'الوصف',
    verified: 'موثّق',
    unverified: 'غير موثّق',
    verifyFilterLabel: 'فلتر التحقق',
    staff: 'الموظف',
    balance: 'الرصيد',
    initialBalance: 'الرصيد الابتدائي',
    debit: 'مدين',
    transactionType: 'نوع المعاملة',
    source: 'المصدر',
    sourceId: 'معرف المصدر',
    orderType: 'نوع الطلب',
    orderTypeName: 'اسم نوع الطلب',
    phone2: 'الهاتف 2',
    receivedDeliveryAmount: 'مبلغ التوصيل المستلم',
    preview: 'معاينة',
    linkUrl: 'الرابط (URL)',
    qrCode: 'رمز QR',
    domain: 'النطاق',
    platform: 'المنصة',
    invoiceNumber: 'رقم الفاتورة',
    refundBy: 'استرداد بواسطة',
    confirmDate: 'تاريخ التأكيد',
    fromDate: 'من تاريخ',
    toDate: 'إلى تاريخ',
    buyCost: 'تكلفة الشراء',
    intShipping: 'الشحن الدولي',
    usdPrice: 'سعر الدولار',
    tlPrice: 'سعر الليرة التركية',
    exchangeDate: 'تاريخ الصرف',
    book: 'الدفتر',
    fromBank: 'من البنك',
    toBank: 'إلى البنك',
    expenseAmount: 'مبلغ المصروف',
    iqdSell: 'بيع الدينار العراقي',
    iqdBuy: 'شراء الدينار العراقي',
    tlSell: 'بيع الليرة التركية',
    tlBuy: 'شراء الليرة التركية',
    aedSell: 'بيع الدرهم الإماراتي',
    aedBuy: 'شراء الدرهم الإماراتي',
    cnySell: 'بيع اليوان الصيني',
    cnyBuy: 'شراء اليوان الصيني',
    gbpSell: 'بيع الجنيه الإسترليني',
    gbpBuy: 'شراء الجنيه الإسترليني',
    eurSell: 'بيع اليورو',
    eurBuy: 'شراء اليورو',
    expenseType: 'نوع المصروف',
    supplierInvoiceNo: 'رقم فاتورة المورد',
    supplier: 'المورد',
    expenseDate: 'تاريخ المصروف',
    noAbbreviation: 'رقم'
  },
  orders: {
    newOrdersTitle: 'الطلبات الجديدة',
    pendingAnswerOrdersTitle: 'الطلبات بانتظار الرد',
    processedOrdersTitle: 'الطلبات المعالجة',
    canceledOrdersTitle: 'الطلبات الملغاة',
    processOrderTooltip: 'معالجة الطلب',
    approveThisOrderTooltip: 'الموافقة على هذا الطلب',
    returnToNewOrderTooltip: 'إرجاع إلى الطلبات الجديدة',
    returnToShipOnlyTooltip: 'إرجاع إلى الشحن فقط',
    errorOccurredProcessingOrder: 'حدث خطأ أثناء معالجة هذا الطلب',
    errorOccurredSubmittingOrders: 'حدث خطأ أثناء إرسال الطلبات',
    couldNotFetchOrderDetails: 'تعذر جلب تفاصيل الطلب',
    failedToCancelOrder: 'فشل إلغاء الطلب',
    sumOfSelectedOrdersLabel: 'مجموع الطلبات المحددة',
    failedToSendOrdersToIntShipment: 'فشل إرسال الطلبات إلى الشحن الدولي',
    failedToSendOrdersToBranchDelivery: 'فشل إرسال الطلبات إلى توصيل الفرع',
    failedToUnclearOrders: 'فشل إلغاء تصفية الطلبات',
    failedToMarkOrdersAsDelivered: 'فشل تحديد الطلبات كمُسلَّمة',
    missingQrCodeForMessage: 'رمز QR مفقود لـ: {list}. تم تسليم البقية بنجاح — أنشئ رمز QR لهذه وحاول مرة أخرى.',
    customerHasLoanMustPayMessage: 'هذا العميل ({name}) لديه دين ويجب أن يدفع على الأقل ${amount}',
    returnToProcessedOrderTooltip: 'إرجاع إلى الطلبات المعالجة',
    ordersReturnedToNewOrderSection: 'تم إرجاع الطلبات إلى قسم الطلبات الجديدة',
    orderUpdatedTitle: 'تم تحديث الطلب',
    pleaseSelectOrderToPurchase: 'يرجى تحديد طلب واحد على الأقل للشراء',
    pleaseRefreshPageAndTryAgain: 'يرجى تحديث الصفحة والمحاولة مرة أخرى',
    pleaseCheckOrderToApprove: 'الرجاء تحديد طلب واحد على الأقل للموافقة عليه',
    onceConfirmedAllApproved: 'بعد التأكيد، سيتم الموافقة على جميع الطلبات المحددة',
    viewOrderInvoiceConfirm: 'هل تريد عرض فاتورة هذا الطلب؟',
    pleaseSelectOrderToDelete: 'الرجاء تحديد طلب واحد على الأقل للحذف',
    deleteSelectedCanceledOrdersConfirm: 'حذف جميع الطلبات الملغاة المحددة؟ لا يمكن التراجع عن هذا من هذه الشاشة.',
    permanentlyDeleteTitle: 'حذف نهائي؟',
    permanentlyDeleteCanceledOrdersConfirm: 'هذا يزيل الطلبات الملغاة المحددة من قاعدة البيانات بشكل كامل — على عكس "حذف الطلبات المحددة"، لا يمكن استرجاع هذا. سجل معاملات العميل ورصيده لن يتأثرا.',
    undoCancelOrderConfirm: 'التراجع عن إلغاء الطلب سيعيد الطلب إلى الحالة السابقة.',
    warehouseDeliveredOrdersTitle: 'الطلبات المسلّمة للمستودع',
    allOrdersTitle: 'جميع الطلبات',
    deliveredToErbilOrdersTitle: 'الطلبات المسلّمة لأربيل',
    purchasedOrdersTitle: 'الطلبات المشتراة',
    approvedOrdersTitle: 'الطلبات الموافق عليها',
    internationalShipmentOrdersTitle: 'طلبات الشحن الدولي',
    pendingToBranchOrdersTitle: 'الطلبات بانتظار الفرع',
    refundedOrdersTitle: 'الطلبات المستردة',
    customerDeliveredOrdersTitle: 'الطلبات المسلّمة للعميل',
    exportableOrdersTitle: 'الطلبات القابلة للتصدير',
    warehousePassedOrdersTitle: 'الطلبات المتجاوزة للمستودع',
    purchaseHistoryTitle: 'سجل المشتريات',
    viewShippingInvoiceTooltip: 'عرض فاتورة الشحن',
    generateQrCodeTooltip: 'إنشاء رمز QR',
    generateInvoiceTooltip: 'إنشاء فاتورة',
    moveToDamageTooltip: 'نقل إلى التالف',
    moveToReturnTooltip: 'نقل إلى المرتجع',
    sendToCustomerTooltip: 'إرسال إلى العميل',
    copyToNewOrderTooltip: 'نسخ إلى طلب جديد',
    refundThisOrderTooltip: 'استرداد هذا الطلب',
    addOrderNumberTooltip: 'إضافة رقم الطلب',
    orderNumberAddedSuccessfully: 'تمت إضافة رقم الطلب بنجاح',
    addWarehouseDateTooltip: 'إضافة تاريخ المستودع',
    purchaseThisOrderTooltip: 'شراء هذا الطلب',
    addBarcodeTooltip: 'إضافة باركود',
    deliverToPendingToBranchTooltip: 'تسليم إلى بانتظار الفرع',
    sendToBranchDeliveryTooltip: 'إرسال إلى توصيل الفرع',
    deliverToBranchTooltip: 'تسليم إلى الفرع',
    pleaseSelectOrderOrCustomer: 'الرجاء تحديد طلب أو عميل واحد على الأقل!',
    selectedDifferentCustomers: 'لقد حددت عملاء مختلفين',
    someOrdersAlreadyInvoiced: 'بعض الطلبات المحددة تمت فوترتها بالفعل',
    copyToNewOrderConfirmTitle: 'نسخ إلى طلب جديد؟',
    copyToNewOrderConfirmMessage: 'سيؤدي هذا إلى إلغاء الطلب {id} واسترداد المبلغ كاملاً للعميل وإنشاء نسخة جديدة في الطلبات الجديدة لإعادة التسعير. هل تريد المتابعة؟',
    ordersPurchasedSuccessfully: 'تم شراء الطلبات بنجاح',
    orderPurchasedSuccessfully: 'تم شراء الطلب بنجاح',
    sentSuccessfully: 'تم الإرسال بنجاح',
    onceDeliveredPendingBranchWarning: 'بعد التسليم إلى بانتظار الفرع، لن تتمكن من إرجاع هذا الطلب إلى هذه المرحلة!',
    confirmSendToBranchDelivery: 'سيتم إرسال الطلبات المحددة مباشرة إلى توصيل الفرع.',
    sortByOrder: 'الطلب',
    sortByConfirm: 'التأكيد',
    sortByPurchase: 'الشراء',
    someOrdersNotMarkedDelivered: 'بعض الطلبات لم تُعلَّم كمُسلَّمة',
    orderAlreadyInvoicedTitle: 'تمت فوترة هذا الطلب بالفعل',
    confirmAttachToDeliveryRequest: 'سيتم إرفاق الطلب (الطلبات) المحددة بطلب التوصيل الخاص بهذا العميل — مع إنشاء طلب جديد إذا لم يكن لديه طلب معلق بالفعل.',
    moveToDamageConfirmTitle: 'نقل إلى التالف؟',
    confirmMoveToDamage: 'هل أنت متأكد أنك تريد نقل هذا الطلب إلى حالة التالف؟',
    moveToReturnConfirmTitle: 'نقل إلى المرتجع؟',
    confirmMoveToReturn: 'هل أنت متأكد أنك تريد نقل هذا الطلب إلى حالة المرتجع؟',
    editThisOrderTooltip: 'تعديل هذا الطلب',
    addRefundNumberTooltip: 'إضافة رقم الاسترداد',
    onceSentWarning: 'بعد الإرسال، لن تتمكن من إرجاع هذا الطلب إلى هذه المرحلة!',
    onceSentPluralWarning: 'بعد الإرسال، لن تتمكن من إرجاع هذه الطلبات إلى هذه المرحلة!',
    confirmGenerateQrSendIntShipment: 'سيتم إنشاء رموز QR للطلبات المحددة وإرسالها مباشرة إلى الشحن الدولي.',
    confirmSendDirectlyToBranchDelivery: 'سيتم إرسال هذا الطلب مباشرة إلى توصيل الفرع. لن تتمكن من إرجاعه إلى هذه المرحلة!',
    pendingShipmentTooltip: 'بانتظار الشحن',
    sendToIntShipmentTitle: 'إرسال إلى الشحن الدولي',
    returnToPurchaseTooltip: 'إرجاع إلى الشراء',
    takePhotoTooltip: 'التقاط صورة',
    createCaseTooltip: 'إنشاء حالة',
    pleaseAtLeastSelectOneOrder: 'الرجاء تحديد طلب واحد على الأقل!',
    currentPageScopeNote: 'الصفحة الحالية',
    filtersToggleLabel: 'الفلاتر',
    oncePendingShipmentedWarning: 'بعد وضعه بانتظار الشحن، لن تتمكن من إرجاع هذا الطلب إلى هذه المرحلة!',
    confirmReturnToPurchasedSection: 'هل تريد فعلاً إرجاع هذا الطلب إلى قسم المشترى؟',
    damageOrdersTitle: 'طلبات التلف',
    returnOrdersTitle: 'طلبات الإرجاع',
    cancelOrderTooltip: 'إلغاء الطلب',
    newExportOrdersTitle: 'طلبات التصدير الجديدة',
    processedExportOrdersTitle: 'طلبات التصدير المعالجة',
    canceledExportOrdersTitle: 'طلبات التصدير الملغاة',
    approvedExportOrdersTitle: 'طلبات التصدير الموافق عليها',
    sentExportOrdersTitle: 'طلبات التصدير المرسلة',
    receivedExportOrdersTitle: 'طلبات التصدير المستلمة',
    exportHistoryTitle: 'سجل التصدير',
    refundedExportOrdersTitle: 'طلبات التصدير المستردة',
    processTooltip: 'معالجة',
    cancelTooltip: 'إلغاء',
    approveTooltip: 'موافقة',
    sendTooltip: 'إرسال',
    receiveTooltip: 'استلام',
    partialRefundTooltip: 'استرداد جزئي',
    fullRefundTooltip: 'استرداد كامل',
    approvedStatusTitle: 'تمت الموافقة',
    sentStatusTitle: 'تم الإرسال',
    receivedStatusTitle: 'تم الاستلام',
    pendingToShipmentOrdersTitle: 'الطلبات بانتظار الشحن',
    shipmentThisOrderTooltip: 'شحن هذا الطلب',
    onceShipmentedWarning: 'بعد الشحن، لن تتمكن من إرجاع هذا الطلب إلى هذه المرحلة!',
    notFoundOrdersTitle: 'الطلبات غير الموجودة',
    trashTooltip: 'حذف',
    allowToSendTooltip: 'السماح بالإرسال',
    convertToOrderTooltip: 'تحويل إلى طلب',
    convertToOrderTitle: 'تحويل إلى طلب',
    deliveredToErbilOption: 'تم التسليم إلى أربيل',
    addedTitle: 'تمت الإضافة',
    orderCasesTitle: 'حالات الطلبات',
    sendToStaffTooltip: 'إرسال إلى الموظف',
    refundTooltip: 'استرداد',
    replaceTooltip: 'استبدال',
    imagesTooltip: 'الصور',
    orderCaseProgressTitle: 'متابعة حالة الطلب',
    convertedToOrderStatus: 'تم التحويل إلى طلب',
    pendingStatus: 'قيد الانتظار',
    processingStatus: 'قيد المعالجة',
    viewDetails: 'عرض التفاصيل',
    cancelThisOrder: 'إلغاء هذا الطلب',
    sendToPendingAnswerTooltip: 'إرسال إلى بانتظار الرد',
    sendToProcessTooltip: 'إرسال للمعالجة',
    orderSort: 'ترتيب الطلبات',
    dateTypeLabel: 'نوع التاريخ',
    newestFirst: 'الأحدث أولاً',
    oldestFirst: 'الأقدم أولاً',
    homeDelivery: 'توصيل منزلي',
    officeDelivery: 'توصيل للمكتب',
    sendThisOrderToProcess: 'إرسال هذا الطلب للمعالجة؟',
    sendAllSelectedToProcess: 'إرسال جميع الطلبات المحددة للمعالجة؟',
    sendToPendingAnswerConfirm: 'إرسال إلى بانتظار الرد',
    pleaseSelectOrder: 'الرجاء تحديد طلب',
    warehousesPlaceholder: 'المستودعات',
    processThisOrderTooltip: 'معالجة هذا الطلب',
    theOrderIsProcessed: 'تمت معالجة الطلب',
    editOrderInfoSection: 'تعديل معلومات الطلب',
    customerLockedHint: 'مقفل — استخدم إعادة تعيين عميل الطلب لتغيير العميل',
    requestName: 'اسم الطلب',
    requestLink: 'رابط الطلب',
    uploadOrderImage: 'رفع صورة الطلب',
    requestDescription: 'وصف الطلب',
    editOrderPriceSection: 'تعديل سعر الطلب',
    itemPriceLabel: 'سعر المنتج ({unit})',
    discountedShippingPriceLabel: 'سعر الشحن بعد الخصم ($)',
    discountLabel: 'الخصم ({unit})',
    deliveryIqdLabel: 'التوصيل (دينار عراقي)',
    estimateTimeToArrivalLabel: 'الوقت المتوقع للوصول (أيام)',
    customerProcessNoteLabel: 'ملاحظة معالجة العميل',
    uploadImage: 'رفع صورة',
    otherServiceNoteLabel: 'ملاحظة خدمة أخرى',
    reason: 'السبب',
    bulkNewOrdersTitle: 'طلبات جديدة بالجملة',
    allItemsOrderedSuccessfully: 'تم طلب جميع العناصر بنجاح!',
    customerRequiredError: 'العميل مطلوب',
    warehouseCountryLabel: 'المستودع / الدولة',
    warehouseRequiredError: 'المستودع مطلوب',
    itemNamePlaceholder: 'اسم العنصر',
    addRowButton: 'إضافة صف',
    countPlaceholder: 'العدد',
    numberOfRowsToAddHint: 'عدد الصفوف المراد إضافتها (0 أو فارغ = 1)',
    itemsTotalLabel: '{count} عنصر بالإجمالي',
    sendToPurchaseLabel: 'إرسال للشراء',
    submitAllOrdersButton: 'إرسال جميع الطلبات',
    removeRowTitle: 'إزالة الصف',
    pickColorTitle: 'اختر لوناً',
    maxOrdersLimitError: 'يمكنك إضافة ما يصل إلى {max} طلباً في المرة الواحدة.',
    onlyRowsAddedLimitError: 'تمت إضافة {count} صف فقط — تم الوصول إلى حد {max} طلباً.',
    unsupportedImageTypeError: 'الملف "{fileName}" ليس نوع صورة مدعوماً. المسموح به: {allowed}.',
    fileSizeLimitError: 'الملف "{fileName}" يتجاوز الحد الأقصى للحجم البالغ 50 ميجابايت.',
    uploadingImagesProgress: 'جارٍ رفع الصور {done}/{total}...',
    savingOrders: 'جارٍ حفظ الطلبات...',
    gifSizeLimitError: 'ملف GIF "{fileName}" يتجاوز الحد الأقصى 2 ميجابايت. يرجى استخدام JPG أو PNG بدلاً منه.',
    imagesStillProcessingError: 'لا تزال بعض الصور قيد التجهيز. يرجى الانتظار قليلاً ثم الإرسال مرة أخرى.',
    uploadTooLargeError: 'حجم الرفع كبير جداً بالنسبة للخادم. يرجى رفع صور أقل أو أصغر حجماً.',
    rowItemNameRequiredError: 'الصف {row}: اسم العنصر مطلوب.',
    rowLinkRequiredError: 'الصف {row}: الرابط (URL) مطلوب.',
    rowQuantityMinError: 'الصف {row}: يجب أن تكون الكمية 1 على الأقل.',
    viewOrderDetailsTitle: 'عرض تفاصيل الطلب',
    itemPriceCurrencyLabel: 'سعر المنتج {code}',
    refundAmountLabel: 'مبلغ الاسترداد',
    partialRefundsLabel: 'الاستردادات الجزئية',
    partialRefundAtBy: 'في {date} بواسطة {name}',
    newOrderTitle: 'طلب جديد',
    itemOrderedSuccessfully: 'تم طلب العنصر بنجاح',
    urlFormatNotAcceptable: 'صيغة الرابط غير مقبولة',
    intShippingUsdLabel: 'الشحن الدولي ($)',
    imageUrlOptionalLabel: 'رابط الصورة (اختياري)',
    urlWillBeUsedInsteadHint: 'سيتم استخدام الرابط بدلاً من رفع ملف',
    purchaseBankLabel: 'بنك الشراء',
    otherServiceSpecifyLabel: 'خدمة أخرى (يرجى التحديد)',
    couponCodeRequiredError: 'يجب أن يحتوي هذا الحقل على رمز كوبون',
    fileSizeExceedsError: 'يجب ألا يتجاوز {field} حجم {size} ميجابايت.',
    unsupportedImageTypeShort: 'نوع صورة غير مدعوم. المسموح به: {allowed}.',
    fileSizeLimitShort: 'يتجاوز الملف الحد الأقصى 50 ميجابايت.',
    uploadPhotoButton: 'رفع صورة',
    partialRefundInvoiceTitle: 'فاتورة الاسترداد الجزئي',
    newStatus: 'جديد',
    updateShipOnlyTitle: 'تحديث الشحن فقط',
    newShipOnlyTitle: 'شحن فقط جديد',
    orderedSuccessfully: 'تم الطلب بنجاح',
    fromDateGreaterThanTodayError: 'يجب أن يكون تاريخ البدء أكبر من اليوم',
    toDateGreaterThanFromDateError: 'يجب أن يكون تاريخ الانتهاء أكبر من تاريخ البدء'
  },
  delivery: {
    orderDeliveryTitle: 'توصيل الطلب',
    changeStatusTooltip: 'تغيير الحالة',
    viewInvoiceTooltip: 'عرض الفاتورة',
    viewCustomerOrdersImagesTooltip: 'عرض طلبات وصور العميل',
    editDeliveryPriceTooltip: 'تعديل سعر التوصيل',
    deliveryRequestDeleteConfirm: 'سيتم حذف طلب التوصيل هذا نهائياً.',
    deletedTitle: 'تم الحذف',
    deliveryPriceIqdTitle: 'سعر التوصيل (دينار عراقي)',
    deliveryPricePlaceholder: 'سعر التوصيل',
    pleaseSelectAtLeastOneDeliveryRequest: 'الرجاء تحديد طلب توصيل واحد على الأقل!',
    postStatus: 'نشر',
    holdStatus: 'تعليق',
    completeStatus: 'مكتمل',
    orderDeliveryInvoiceTitle: 'فاتورة توصيل الطلب',
    invoicedToLabel: 'مفوترة إلى',
    phone2Label: 'الهاتف 2',
    detachTooltip: 'فصل عن طلب التوصيل هذا',
    orderNumberColumn: 'رقم الطلب',
    totalOrdersLabel: 'إجمالي الطلبات:',
    totalUsdLabel: 'إجمالي الدولار:',
    iraqiDinarLabel: 'الدينار العراقي:',
    totalIqdColonLabel: 'إجمالي الدينار العراقي:',
    attachedOrdersNotYetInvoiced: 'طلبات مرفقة (لم تُفوتر بعد)',
    orderColumn: 'الطلب',
    productColumn: 'المنتج',
    detachConfirmTitle: 'فصل هذه الفاتورة؟',
    detachConfirmText: 'لن تعود {invoice} جزءاً من طلب التوصيل هذا. ستبقى فاتورة شحن عادية ويمكن إرفاقها مرة أخرى لاحقاً.',
    deliveryInvoiceTitle: 'فاتورة التوصيل',
    customerBalanceLabel: 'رصيد العميل:',
    deliveryMethodLabel: 'طريقة التوصيل:',
    pickupInOfficeLabel: 'استلام (من المكتب)',
    payOnDeliveryLabel: 'الدفع عند التوصيل:',
    deliveryInvoicesTitle: 'فواتير التوصيل',
    invoiceSelectedCount: '{count} فاتورة محددة',
    selectStatusLabel: 'اختر الحالة',
    totalRecordsFooter: 'إجمالي السجلات: {count}',
    totalPriceFooter: 'إجمالي السعر: {amount}',
    totalDeliveryPriceFooter: 'إجمالي سعر التوصيل: {amount} دينار عراقي',
    deliveryPriceFooter: 'سعر التوصيل: {amount} دينار عراقي',
    viewShippingInvoicesTooltip: 'عرض {count} فاتورة شحن',
    thisDeliveryInvoiceWillBeDeleted: 'سيتم حذف فاتورة التوصيل هذه نهائياً.',
    pleaseSelectAtLeastOneDeliveryInvoice: 'يرجى تحديد فاتورة توصيل واحدة على الأقل!',
    markAllSelectedInvoicesAsReceivedConfirm: 'سيؤدي هذا إلى تعليم جميع فواتير التوصيل المحددة كمستلمة.',
    unmarkAllSelectedInvoicesAsReceivedConfirm: 'سيؤدي هذا إلى إلغاء تعليم جميع فواتير التوصيل المحددة كمستلمة (سيتم مسح المبالغ والتاريخ المستلم).',
    partialReceivedStatus: 'مستلم جزئياً',
    payOnDeliveryIqdLabel: 'الدفع عند الاستلام (دينار عراقي)',
    pickupLabel: 'استلام',
    notConfirmedLabel: 'غير مؤكد',
    requestDeliveryTitle: 'طلب توصيل',
    customerRequiredLabel: 'العميل*',
    noteOptionalLabel: 'ملاحظة (اختياري)',
    changeStatusTitle: 'تغيير الحالة',
    requestsSelectedSuffix: 'طلب(ات) محددة',
    invoiceColonPrefix: 'الفاتورة:',
    custNoteColumn: 'ملاحظة العميل',
    createdColumn: 'تاريخ الإنشاء'
  },
  invoice: {
    shippingInvoiceTitle: 'فاتورة الشحن',
    receivedInvoicesTitle: 'الفواتير المستلمة',
    invoiceTooltip: 'الفاتورة',
    recordPaymentTooltip: 'تسجيل الدفع',
    logsTooltip: 'السجلات',
    failedToDeleteInvoice: 'فشل حذف الفاتورة — لم يتم إزالتها.',
    somethingWentWrong: 'حدث خطأ ما!',
    pleaseSelectAtLeastOneInvoice: 'الرجاء تحديد فاتورة واحدة على الأقل!',
    ordersInvoiceTitle: 'فاتورة الطلبات',
    creditInvoiceTitle: 'فاتورة الرصيد',
    confirmMarkAllPaid: 'سيتم وضع علامة على جميع الفواتير المحددة بأنها مدفوعة بالكامل.',
    confirmMarkAllReceived: 'سيتم وضع علامة على جميع الفواتير المحددة كمستلمة.',
    confirmUnmarkAllReceived: 'سيتم إلغاء وضع علامة الاستلام عن جميع الفواتير المحددة (سيتم مسح المالك وتاريخ الاستلام والمبلغ المستلم).',
    cashReceivedInDaysLabel: 'النقد المستلم في هذه الأيام:',
    cashReceivedInDaysHint: 'المبلغ الجديد فقط الذي تم تسليمه في تواريخ الاستلام المحددة. بخلاف إجمالي المستلم، لا يتغير عند استلام الفاتورة مرة أخرى لاحقاً.',
    confirmToggleOutOffice: 'سيتم تبديل حالة "خارج المكتب" للفواتير المحددة.',
    pleaseSelectAtLeastTwoPaidInvoices: 'الرجاء تحديد فاتورتين مدفوعتين على الأقل للدمج!',
    paidStatus: 'مدفوع',
    partialPaidStatus: 'مدفوع جزئياً',
    unpaidStatus: 'غير مدفوع',
    receivedAtOption: 'تاريخ الاستلام',
    singleOption: 'مفرد',
    batchOption: 'دفعة',
    digitalOption: 'رقمي',
    officeOption: 'المكتب',
    manualOption: 'يدوي',
    refundExistsOption: 'يوجد استرداد',
    noRefundOption: 'لا يوجد استرداد',
    generateInvoiceTitle: 'إنشاء فاتورة',
    customerLabel: 'العميل: {name}',
    phoneNumberLabel: 'رقم الهاتف: {phone}',
    ordersLabel: 'الطلبات',
    shipmentLabel: 'الشحنة',
    handlingFeeLabel: 'رسوم المناولة',
    totalPriceLabel: 'السعر الإجمالي',
    totalIqdLabel: 'الإجمالي بالدينار العراقي',
    paidAmountLabel: 'المبلغ المدفوع',
    remainingAfterSelectedOrders: 'المتبقي بعد فواتير الطلبات المحددة الحالية: {usd} / {iqd} دينار عراقي',
    remainingFromOtherPartialInvoices: 'المتبقي من فواتير أخرى مدفوعة جزئياً: {usd} / {iqd} دينار عراقي',
    loadingText: 'جارٍ التحميل...',
    balanceLabel: 'الرصيد',
    remainingBalanceLabel: 'الرصيد المتبقي',
    shippingInvoiceNoLabel: 'رقم فاتورة الشحن:',
    customerOutOfficeTotalNote: 'إجمالي خارج المكتب لهذا الزبون: {amount}',
    cashAndView: 'نقداً وعرض',
    outOfficeButton: 'خارج المكتب',
    viewButton: 'عرض',
    deliveryButton: 'توصيل',
    cancelStatus: 'إلغاء',
    notPaidWatermark: 'غير مدفوع',
    invoiceNoteLabel: 'ملاحظة الفاتورة:',
    secondaryInvoiceGeneratedNote: 'تم إنشاء فاتورة ثانوية لهذا الطلب',
    invoiceSavedNoPreview: 'تم حفظ الفاتورة ولكن تعذر فتح المعاينة (معرف الفاتورة مفقود).',
    invoiceGeneratedSuccessfully: 'تم إنشاء الفاتورة بنجاح',
    requestFailed: 'فشل الطلب',
    invoiceSavedNoAttach: 'تم حفظ الفاتورة ولكن تعذر إرفاقها بالتوصيل (معرف الفاتورة مفقود).',
    attachFailed: 'فشل الإرفاق',
    invoiceCreatedCouldNotAttach: 'تم إنشاء الفاتورة، لكن تعذر إرفاقها: {msg}',
    alreadyAttachedNote: '{list} مرفقة بالفعل بطلب توصيل — لم يتم إرفاقها مرة أخرى.'
  },
  navbar: {
    creditLabel: 'الرصيد:',
    addBalance: 'إضافة رصيد',
    subscription: 'الاشتراك',
    exchangeRateLabel: 'سعر الصرف:',
    capital: 'رأس المال',
    verifyAccountButton: 'تحقق من حسابك',
    printLogs: 'سجلات الطباعة',
    warehouseDatePassedOrders: 'طلبات تجاوزت تاريخ المستودع',
    warehouseDateLabel: 'تاريخ المستودع:',
    notifications: 'الإشعارات'
  },
  sidebar: {
    toggleAllNavigations: 'تبديل كل القوائم',
    dashboard: 'لوحة التحكم',
    statisticsDashboard: 'لوحة الإحصائيات',
    loanedCustomerTitle: 'عميل مقترض',
    customerPricesTitle: 'أسعار العملاء',
    orderCasesProgressTitle: 'تقدم حالات الطلبات',
    orderTypesTitle: 'أنواع الطلبات',
    chargeBalanceTitle: 'شحن الرصيد',
    shipOnlyNewTitle: 'الشحن فقط (جديد)',
    orderInvoicesTitle: 'فواتير الطلبات',
    shippingInvoicesTitle: 'فواتير الشحن',
    creditInvoicesTitle: 'فواتير الرصيد',
    partialRefundInvoicesTitle: 'فواتير الاسترداد الجزئي',
    orders: 'الطلبات',
    tools: 'أدوات',
    export: 'التصدير',
    import: 'الاستيراد',
    delivery: 'التوصيل',
    invoices: 'الفواتير',
    finance: 'المالية',
    cases: 'الحالات',
    customers: 'العملاء',
    reports: 'التقارير',
    mobileApp: 'تطبيق الموبايل',
    admin: 'الإدارة'
  },
  warehouse: {
    warehousesTitle: 'المستودعات',
    updateWarehouseTitle: 'تحديث المستودع',
    warehouseUpdatedSuccessfully: 'تم تحديث المستودع بنجاح',
    estimateDaysLabel: 'أيام التقدير (فترة التوصيل)',
    houseNumberLabel: 'رقم المنزل',
    stateProvinceLabel: 'الولاية - المحافظة',
    prefixLabel: 'البادئة',
    flagCodeHint: 'رمز العلم (حرفان ISO، مثال: tr, us, ae, cn, gb, de)',
    customCodeLabel: 'الرمز المخصص',
    transportationTypesLabel: 'أنواع النقل',
    defaultImageLabel: 'الصورة الافتراضية'
  },
  user: {
    staffTitle: 'الموظفون',
    totalIncomeAddLabel: 'إجمالي الدخل (إضافة +)',
    totalOutgoingCashBackLabel: 'إجمالي الصادر (استرداد نقدي -)',
    verifiedAtLabel: 'تم التحقق في',
    customersTitle: 'العملاء',
    editCustomerTooltip: 'تعديل العميل',
    customerTransactionTooltip: 'معاملات العميل',
    customerTransactionsTitle: 'معاملات {name}',
    removeFilterButton: 'إزالة الفلتر',
    openingBalanceLabel: 'الرصيد الافتتاحي',
    updateCustomerTitle: 'تحديث العميل',
    codEnabledLabel: 'الدفع عند الاستلام',
    codEnabledHint: 'السماح لهذا العميل بالموافقة على الطلبات بدون رصيد في المحفظة',
    block: 'حظر',
    unblock: 'إلغاء الحظر',
    editStaffTooltip: 'تعديل الموظف',
    resetPasswordTooltip: 'إعادة تعيين كلمة المرور',
    resetPasswordSuccessfully: 'تمت إعادة تعيين كلمة المرور بنجاح',
    blockThisUserTooltip: 'حظر هذا المستخدم',
    unblockThisUserTooltip: 'إلغاء حظر هذا المستخدم',
    notAllowed: 'غير مسموح',
    cannotResetOwnPassword: 'لا يمكنك إعادة تعيين كلمة المرور الخاصة بك من هنا، يمكنك فقط إعادة تعيين كلمة المرور للآخرين',
    personalInformation: 'المعلومات الشخصية',
    updateCoverImageButton: 'تحديث صورة الغلاف',
    fullName: 'الاسم الكامل',
    addCustomerTitle: 'إضافة عميل',
    customerFullNameLabel: 'الاسم الكامل للعميل',
    fullNameTwoWordsError: 'يجب أن يحتوي الاسم الكامل على كلمتين على الأقل مفصولتين بمسافة',
    addStaffTitle: 'إضافة موظف',
    staffAddedSuccessfully: 'تمت إضافة الموظف بنجاح',
    passwordDoNotMatch: 'كلمة المرور غير متطابقة',
    phoneMustStartWith964Error: 'يجب أن يبدأ رقم الهاتف بـ +964',
    updateStaffTitle: 'تحديث الموظف',
    staffUpdatedSuccessfully: 'تم تحديث الموظف بنجاح',
    changePasswordTitle: 'تغيير كلمة المرور',
    currentPassword: 'كلمة المرور الحالية',
    newPassword: 'كلمة المرور الجديدة',
    confirmPassword: 'تأكيد كلمة المرور',
    changeSecretKeyTitle: 'تغيير المفتاح السري',
    currentSecret: 'المفتاح السري الحالي',
    newSecret: 'المفتاح السري الجديد',
    confirmSecret: 'تأكيد المفتاح السري',
    createSecretKeyTitle: 'إنشاء مفتاح سري',
    secretKey: 'المفتاح السري',
    companyInfoTitle: 'معلومات الشركة',
    companyName: 'اسم الشركة',
    companyEmail: 'بريد الشركة الإلكتروني',
    companyAddress: 'عنوان الشركة',
    confirmPasswordNotMatch: 'تأكيد كلمة المرور غير متطابق',
    passwordChangedSuccessfully: 'تم تغيير كلمة المرور بنجاح',
    currentPasswordIncorrect: 'كلمة المرور الحالية غير صحيحة',
    profileMustBeImage: 'يجب أن تكون الصورة الشخصية صورة',
    coverMustBeImage: 'يجب أن تكون صورة الغلاف صورة',
    secretKeyIncorrect: 'المفتاح السري الحالي غير صحيح',
    secretKeyChangedSuccessfully: 'تم تغيير المفتاح السري بنجاح',
    currentSecretKeyRequired: 'المفتاح السري الحالي مطلوب',
    newSecretKeyRequired: 'المفتاح السري الجديد مطلوب',
    confirmSecretKeyRequired: 'تأكيد المفتاح السري مطلوب',
    confirmSecretNotMatch: 'تأكيد المفتاح السري غير متطابق',
    secretKeyCreatedSuccessfully: 'تم إنشاء المفتاح السري بنجاح',
    alreadyHaveSecretKey: 'لديك مفتاح سري بالفعل',
    secretKeyRequired: 'المفتاح السري مطلوب',
    companyInfoUpdatedSuccessfully: 'تم تحديث معلومات الشركة بنجاح',
    customerSubscriptionsTitle: 'اشتراكات العملاء',
    editSubscriptionTooltip: 'تعديل الاشتراك',
    deleteCustomerSubscriptionTooltip: 'حذف اشتراك العميل',
    pleaseSelectAtLeastOneSubscriptionToDelete: 'الرجاء تحديد اشتراك عميل واحد على الأقل للحذف',
    deleteCustomerSubscriptionConfirm: 'حذف اشتراك العميل: {name}؟',
    deleteAllCustomerSubscriptionsConfirm: 'حذف جميع اشتراكات العملاء المحددة؟',
    customerCreditTitle: 'رصيد العميل',
    onceDeletedCreditWarning: 'بعد الحذف، لن تتمكن من استرجاع هذا الرصيد!',
    onceDeletedCashBackWarning: 'بعد الحذف، لن تتمكن من استرجاع هذا الكاش باك!',
    customerDefaultPricesTitle: 'الأسعار الافتراضية للعميل'
  },
  reports: {
    salesReportTitle: 'تقرير المبيعات',
    gainedReportTitle: 'تقرير الأرباح',
    expensesReportTitle: 'تقرير المصاريف',
    invoicesReportTitle: 'تقرير الفواتير',
    orderCostsReportTitle: 'تقرير تكاليف الطلبات',
    buysReportTitle: 'تقرير المشتريات',
    customersReportTitle: 'تقرير العملاء',
    customerInvoicesReportTitle: 'تقرير فواتير العملاء',
    deliveryReportTitle: 'تقرير التوصيل',
    dailyRevenueReportTitle: 'تقرير الإيرادات اليومية',
    deliveredReportTitle: 'تقرير المُسلَّم',
    profitReportTitle: 'تقرير الربح',
    unpaidArrivedInvoicesTitle: 'الفواتير الواصلة غير المدفوعة',
    unpaidReceivedInvoicesTitle: 'الفواتير المستلمة غير المدفوعة',
    ordersReportTitle: 'تقرير الطلبات',
    revenueReportTitle: 'تقرير الإيرادات',
    orderStatusReportTitle: 'تقرير حالة الطلبات',
    numberOfOrders: 'عدد الطلبات',
    numberOfRequests: 'عدد الطلبات',
    totalRequests: 'إجمالي الطلبات',
    totalBuy: 'إجمالي الشراء',
    totalExpenses: 'إجمالي المصاريف',
    totalSales: 'إجمالي المبيعات',
    totalGained: 'إجمالي الأرباح',
    staffMember: 'الموظف',
    paymentStatus: 'حالة الدفع',
    count: 'العدد',
    paid: 'المدفوع',
    transportation: 'وسيلة النقل',
    totalCost: 'إجمالي التكلفة',
    net: 'الصافي',
    totalRevenue: 'إجمالي الإيرادات',
    orderCount: 'عدد الطلبات',
    request: 'الطلب',
    exchangeDifference: 'فرق الصرف',
    shippingCost: 'تكلفة الشحن',
    deliveryIqd: 'التوصيل (دينار)',
    totalGain: 'إجمالي الربح',
    apply: 'تطبيق',
    printReport: 'طباعة التقرير',
    pleaseSelectFromToDate: 'الرجاء تحديد تاريخ البداية وتاريخ النهاية',
    failedToLoadReport: 'فشل تحميل التقرير',
    pleaseSelectStatusFromToDate: 'الرجاء تحديد الحالة وتاريخ البداية وتاريخ النهاية',
    failedToLoadInvoices: 'فشل تحميل الفواتير',
    customerWhoPlacedOrders: 'العميل الذي قام بالطلب(ات)',
    orderCountSubLabelSuffix: '= عدد الطلبات بالحالة المحددة، من قبل هذا العميل خلال الفترة',
    periodColon: 'الفترة:',
    acrossAllCustomers: 'لجميع العملاء',
    notPaidHeader: 'غير مدفوع',
    notPaidSubLabel: 'فواتير بمبلغ مدفوع = 0',
    partialPaidHeader: 'مدفوع جزئياً',
    partialPaidSubLabel: 'فواتير بين 0 والمبلغ الإجمالي مدفوعة جزئياً',
    paidSubLabel: 'فواتير بمبلغ مدفوع أكبر من أو يساوي الإجمالي',
    equalsInvoiceCount: '= عدد الفواتير',
    equalsSigmaInvoiceAmount: '= مجموع مبلغ الفواتير',
    equalsSigmaAmountPaid: '= مجموع المبلغ المدفوع',
    allCustomersOption: 'جميع العملاء',
    telColonPrefix: 'هاتف: ',
    totalShippingCardTitle: 'إجمالي الشحن',
    equalsSigmaShippingCost: '= مجموع تكلفة الشحن للطلبات المسلمة خلال الفترة',
    totalShipzoneFeeCardTitle: 'إجمالي رسوم ShipZone',
    equalsSigmaShipzoneServiceFee: '= مجموع رسوم خدمة ShipZone للطلبات المسلمة خلال الفترة',
    totalOrders: 'إجمالي الطلبات',
    grandTotal: 'الإجمالي الكلي',
    orderStatusStageHint: 'حالة/مرحلة الطلب',
    equalsCountOrdersWithStatus: '= عدد الطلبات بهذه الحالة',
    equalsSigmaOrderAmount: '= Σ مبلغ الطلب',
    qtyShipTotalPerCountryHint: 'الكمية = N؛ الشحن = Σ الشحن (S)؛ الإجمالي = Σ المبلغ (A) لهذا البلد',
    requestsGroupedByCountryHint: 'الطلبات مجمعة حسب بلد الوجهة',
    ordersGroupedByCountryHint: 'الطلبات مجمعة حسب بلد الوجهة',
    equalsCountBuyRequestsInCountry: '= عدد طلبات الشراء في هذا البلد',
    equalsSigmaOrderAmountPreDiscount: '= Σ مبلغ الطلب (قبل الخصم)',
    equalsSigmaDiscountApplied: '= Σ الخصم المطبق',
    groupedByTransportationMethodHint: 'مجمعة حسب طريقة النقل',
    equalsCountOrdersUsingTransportation: '= عدد الطلبات التي تستخدم طريقة النقل هذه',
    equalsSigmaOrderCostPreDiscount: '= Σ تكلفة الطلب (قبل الخصم)',
    equalsSigmaRevenueCollected: '= Σ الإيرادات المحصلة لهذا النوع من النقل',
    sigmaDeliveriesSigmaIqdHint: 'Σ التوصيلات، Σ دينار عراقي',
    equalsCountOrdersInCountry: '= عدد الطلبات في هذا البلد',
    equalsSigmaOrderAmountForCountry: '= Σ مبلغ الطلب لهذا البلد',
    employeeWhoRecordedExpenseHint: 'الموظف الذي سجل المصروف',
    equalsSigmaExpenseAmountByStaff: '= Σ مبلغ المصروف المسجل من قبل هذا الموظف',
    sigmaAAcrossAllStaffHint: 'ΣA لجميع الموظفين',
    accountStatusActiveInactiveHint: 'حالة الحساب: نشط / غير نشط',
    equalsCustomersWithStatusInPeriod: '= العملاء بهذه الحالة، المسجلون خلال الفترة',
    totalRegistered: 'إجمالي المسجلين',
    invoiceStatusHint: 'حالة الفاتورة: غير مدفوعة / جزئي / مدفوعة',
    equalsInvoicesWithStatus: '= الفواتير بهذه الحالة',
    totalShipmentCardTitle: 'إجمالي الشحن',
    totalTaxCardTitle: 'إجمالي الضريبة',
    invoiceShipmentCardTitle: 'شحن الفاتورة',
    netIncomeCardTitle: 'صافي الدخل',
    equalsSigmaShipmentCost: '= Σ تكلفة الشحن',
    equalsSigmaShipzoneFeeCard: '= Σ رسوم شيب زون',
    equalsSigmaTaxCollected: '= Σ الضريبة المحصلة',
    equalsSigmaShipmentAmountInvoiced: '= Σ مبلغ الشحن المفوتر للعملاء',
    equalsSigmaRefundedAmountCard: '= Σ المبلغ المسترد',
    equalsSigmaBusinessExpenses: '= Σ مصاريف العمل',
    equalsRevenueAfterRefundsFeesBeforeExpenses: '= الإيرادات بعد الاستردادات/الرسوم، قبل المصاريف',
    orderDateHint: 'تاريخ الطلب',
    orderRequestIdHint: 'رقم الطلب / الطلبية',
    equalsItemPriceLocalCurrency: '= سعر المنتج بالعملة المحلية',
    currencyOfPHint: 'عملة P (أحمر = $، أزرق = أخرى)',
    equalsUnitsOnOrder: '= عدد الوحدات في هذا الطلب',
    equalsBuyCostUsd: '= تكلفة الشراء بالدولار',
    equalsPerUnitExchangeMargin: '= هامش الصرف لكل وحدة؛ × Q عندما Q > 1',
    equalsPerUnitShippingCost: '= تكلفة الشحن لكل وحدة؛ × Q عندما Q > 1',
    equalsDeliveryFeeIqd: '= رسوم التوصيل بالدينار العراقي',
    equalsRowGainApprox: '= ربح هذا الصف تقريباً (B + C) × Q',
    totalRevenueAcrossRowsHint: 'ΣB·Q، ΣC·Q، ΣD، ΣE لجميع الصفوف',
    totalRevenueFooterLabel: 'إجمالي الإيرادات:',
    businessExpensesFooterLabel: 'مصاريف العمل:',
    equalsSigmaBusinessExpensesInPeriod: '= Σ مصاريف العمل خلال الفترة',
    netGainAfterExpensesFooterLabel: 'صافي الربح (بعد المصاريف):',
    equalsCountOrdersInPeriod: '= عدد الطلبات خلال الفترة',
    equalsSigmaPurchaseBuyCost: '= Σ تكلفة الشراء',
    equalsSigmaSalesRevenue: '= Σ إيرادات المبيعات'
  },
  mobileApp: {
    aboutAppSectionTitle: 'قسم حول التطبيق',
    helpCenterSectionTitle: 'قسم مركز المساعدة (الأسئلة الشائعة)',
    homeSliderTitle: 'سلايدر الصفحة الرئيسية (التطبيق)',
    addNewHomeSliderButton: 'إضافة سلايدر جديد',
    homeBannerTitle: 'بانر الصفحة الرئيسية للموبايل (التطبيق)',
    popularWebsiteTitle: 'المواقع الشائعة (التطبيق)',
    updatePopularWebsiteTitle: 'تحديث الموقع الشائع',
    addNewPopularWebsiteTitle: 'إضافة موقع شائع جديد',
    globalWebsiteGroupTitle: 'مجموعة المواقع العالمية (التطبيق)',
    websitesAppTitle: 'المواقع (التطبيق)',
    addNewGlobalWebsiteButton: 'إضافة موقع عالمي جديد',
    updateGlobalWebsiteTitle: 'تحديث الموقع العالمي',
    uploadLogo: 'رفع الشعار',
    forceUpdateTitle: 'التحديث الإجباري',
    linksTitle: 'الروابط',
    ourAddressTitle: 'عنواننا',
    updateOurAddressTitle: 'تحديث عنواننا',
    addNewOurAddressTitle: 'إضافة عنوان جديد لنا',
    customerAlreadyInList: 'العميل موجود بالفعل في القائمة',
    pleaseSelectCustomer: 'الرجاء اختيار عميل',
    pleaseEnterTitle: 'الرجاء إدخال العنوان',
    pleaseEnterBody: 'الرجاء إدخال المحتوى'
  },
  admin: {
    couponsTitle: 'الكوبونات',
    editPercentageTooltip: 'تعديل النسبة',
    giveToCustomerTooltip: 'إعطاء للعميل',
    onceDeletedCouponWarning: 'بعد الحذف، لن تتمكن من استرجاع هذا الكوبون!',
    orderLogTitle: 'سجل الطلبات',
    viewStaffTooltip: 'عرض الموظف',
    viewOrderTooltip: 'عرض الطلب',
    viewCustomerTooltip: 'عرض العميل',
    activityLogTitle: 'سجل النشاطات',
    shipZoneFeePricesTitle: 'أسعار رسوم شيب زون',
    suppliersTitle: 'الموردون',
    rolesTitle: 'الأدوار',
    assignPermissionTooltip: 'تعيين الصلاحيات',
    settingsTitle: 'الإعدادات',
    securitySection: 'الأمان',
    profileSection: 'الملف الشخصي',
    onlinePaymentSection: 'الدفع الإلكتروني',
    staleOrdersSection: 'الطلبات المتوقفة',
    requireSecretKeyLabel: 'طلب مفتاح سري للصفحات الحساسة',
    lockFullNameEditLabel: 'قفل تعديل الاسم الكامل (الموبايل) — بمجرد تعيين الاسم الأول والأخير للعميل، لن يتمكن من تغييره بعد ذلك من تطبيق الموبايل',
    allowChangingCanceledStatusLabel: 'السماح بتغيير حالة الطلبات الملغاة (أوقف هذا الخيار لمنع أي تغيير آخر لحالة الطلبات الملغاة)',
    autoCreateShippingInvoicesLabel: 'الإنشاء التلقائي لفواتير الشحن للطلبات المشحونة عند شحن الرصيد (تحصل الطلبات دائماً على فاتورة عند الموافقة، ودائماً ما يسدد شحن الرصيد أي فاتورة موجودة مسبقاً؛ هذا الخيار يتحكم فقط فيما إذا كان شحن رصيد جديد عبر FIB/QI/المكتب سينشئ أو يدمج بشكل استباقي فاتورة للطلبات المشحونة التي لا تملك فاتورة بعد، أو ينتظر قيام الموظف بذلك يدوياً عبر إنشاء فاتورة',
    enableOnlinePaymentLabel: 'تفعيل الدفع الإلكتروني (FIB، QiCard، FastPay، ZainCash) لإضافة الرصيد ودفع الطلبات — أوقف هذا الخيار لحظر جميع طرق الدفع الإلكتروني في التطبيق بالكامل. الدفع عند الاستلام لا يتأثر أبداً بهذا الإعداد.',
    fibCommissionRateLabel: 'نسبة عمولة FIB (%)',
    qiCommissionRateLabel: 'نسبة عمولة بطاقة QI (%)',
    autoCancelStaleOrdersLabel: 'الإلغاء التلقائي للطلبات العالقة في حالة طلب جديد أو طلب معالج',
    hoursBeforeAutoCancelLabel: 'عدد الساعات قبل الإلغاء التلقائي',
    notifyProcessedOrdersLabel: 'إشعار العملاء بالطلبات المعالجة بانتظار موافقتهم (تُرسل على دفعات)',
    hoursBeforeReminderLabel: 'عدد الساعات قبل إشعار التذكير',
    securitySectionDesc: 'يتحكم في الوصول إلى صفحات الإدارة الحساسة.',
    profileSectionDesc: 'يتحكم في كيفية تعديل العملاء لملفهم الشخصي من تطبيق الجوال.',
    ordersSectionDesc: 'قواعد تغيير الحالة وإنشاء الفواتير للطلبات.',
    onlinePaymentSectionDesc: 'توفر FIB/QiCard/FastPay/ZainCash، والعمولة المضافة على مبلغ العميل عند إضافة رصيد عبر FIB أو QI Card. لا تُفرض عمولة أبداً على مدفوعات الطلبات.',
    staleOrdersSectionDesc: 'الإلغاء التلقائي للطلبات العالقة في حالة طلب جديد أو تمت معالجته، وإشعارات التذكير للطلبات المعالجة التي لم يوافق عليها العميل بعد.',
    fibCommissionRateHint: 'تُضاف إلى المبلغ عندما يضيف العميل رصيداً عبر FIB. لا تؤثر على مدفوعات الطلبات.',
    qiCommissionRateHint: 'تُضاف إلى المبلغ عندما يضيف العميل رصيداً عبر QI Card. لا تؤثر على مدفوعات الطلبات.',
    hoursBeforeAutoCancelHint: 'المدة التي يمكن أن يبقى فيها الطلب في حالة طلب جديد أو تمت معالجته قبل إلغائه تلقائياً.',
    hoursBeforeReminderHint: 'المدة التي يمكن أن ينتظر فيها الطلب المعالج موافقة العميل قبل إرسال إشعار تذكير.',
    settingsUpdatedSuccessfully: 'تم تحديث الإعدادات بنجاح',
    pleaseUpdateAnything: 'الرجاء تحديث أي شيء',
    citiesTitle: 'المدن',
    governoratesTitle: 'المحافظات',
    cancellationRefundReasonsTitle: 'أسباب الإلغاء والاسترداد',
    deleteSubscriptionTooltip: 'حذف الاشتراك',
    subscriptionPricingTitle: 'تسعير الاشتراكات',
    pleaseSelectAtLeastOneUserSubscriptionToDelete: 'الرجاء تحديد اشتراك مستخدم واحد على الأقل للحذف',
    editOrderTypeTooltip: 'تعديل نوع الطلب',
    deleteOrderTypeTooltip: 'حذف نوع الطلب',
    deleteOrderTypeConfirm: 'حذف نوع الطلب: {name}؟',
    savedTitle: 'تم الحفظ'
  },
  customer: {
    myOrdersTitle: 'طلباتي',
    orderDetailTooltip: 'تفاصيل الطلب',
    editOrderTooltip: 'تعديل الطلب',
    addTrackNumberTooltip: 'إضافة رقم التتبع',
    archiveThisOrderTooltip: 'أرشفة هذا الطلب',
    onceArchivedWarning: 'بعد الأرشفة، لن تتمكن من إرجاع هذا الطلب إلى هذه المرحلة!',
    archivedTitle: 'تمت الأرشفة',
    orderCanceledLabel: 'الطلب ملغى:',
    refundReason: 'سبب الاسترداد',
    processNote: 'ملاحظة المعالجة',
    processNoteImage: 'صورة ملاحظة المعالجة',
    trackNo: 'رقم التتبع',
    link: 'رابط',
    couponPercentage: 'نسبة الكوبون',
    color: 'اللون',
    deliveryType: 'نوع التوصيل',
    deliveryTypeUpdatedSuccessfully: 'تم تحديث نوع التوصيل بنجاح',
    repackage: 'إعادة التغليف',
    hold: 'تعليق',
    otherService: 'خدمة أخرى',
    quantityCharge: 'رسوم الكمية',
    itemPrice: 'سعر القطعة',
    internationalTax: 'الضريبة الدولية',
    itemType: 'نوع القطعة',
    addItemTypeTitle: 'إضافة نوع قطعة',
    itemAddedSuccessfully: 'تمت إضافة القطعة بنجاح',
    shippingPrice: 'سعر الشحن',
    discountedShippingPrice: 'سعر الشحن بعد الخصم',
    insurance: 'التأمين',
    repackagePrice: 'سعر إعادة التغليف',
    holdPrice: 'سعر التعليق',
    otherServicePrice: 'سعر الخدمة الأخرى',
    handlingFee: 'رسوم المناولة',
    itemWeightLb: 'وزن القطعة (رطل)',
    archivedOrdersTitle: 'الطلبات المؤرشفة',
    orderDate: 'تاريخ الطلب',
    otherServiceSpecify: 'خدمة أخرى (يرجى التحديد)',
    couponCodeValidation: 'يجب أن يحتوي هذا الحقل على رمز الكوبون',
    amountInIqdIs: 'المبلغ بالدينار العراقي هو:',
    scanThisQrCode: 'امسح رمز الاستجابة السريعة',
    payWithLabel: 'الدفع باستخدام',
    minimumAmountHint: 'الحد الأدنى للمبلغ ($0.2) أو (250 دينار عراقي)',
    nextButton: 'التالي',
    enterCodeManuallyHint: 'أو أدخل هذا الرمز يدوياً',
    tryAgainButton: 'حاول مرة أخرى',
    chargeYourAccount: 'اشحن حسابك',
    selectPaymentMethod: 'اختر طريقة الدفع',
    qiPaymentChecking: 'جارٍ التحقق من دفعتك عبر كي…',
    qiPaymentSuccess: 'تم استلام الدفعة — تم تحديث رصيدك.',
    qiPaymentPending: 'لا تزال دفعتك عبر كي قيد المعالجة. سيتم تحديث رصيدك تلقائياً بعد تأكيدها.',
    qiPaymentCancelled: 'تم إلغاء الدفع عبر كي. لم يتم خصم أي مبلغ.',
    qiPaymentFailed: 'فشل الدفع عبر كي. يرجى المحاولة مرة أخرى أو اختيار طريقة دفع أخرى.',
    cancelOrderTitle: 'إلغاء الطلب',
    cancelReasonLabel: 'سبب الإلغاء',
    deliverBranchLabel: 'فرع التسليم',
    approvedTitle: 'تمت الموافقة',
    addAddressTitle: 'إضافة عنوان',
    addTrackNumberTitle: 'إضافة رقم التتبع',
    trackNumberAddedSuccessfully: 'تمت إضافة رقم التتبع بنجاح',
    checkRateTitle: 'التحقق من السعر',
    originCountry: 'بلد المنشأ',
    weightPerPackage: 'الوزن لكل طرد',
    length: 'الطول',
    width: 'العرض',
    height: 'الارتفاع',
    destinationCountry: 'بلد الوجهة',
    documentOption: 'وثيقة',
    noneDocumentOption: 'ليست وثيقة',
    showRateButton: 'عرض السعر',
    invoicesTitle: 'الفواتير',
    partialRefundInvoiceTitle: 'فاتورة الاسترداد الجزئي',
    invoiceDate: 'تاريخ الفاتورة',
    description: 'الوصف',
    exportOrdersTitle: 'طلبات التصدير',
    exportOrderDetailTitle: 'تفاصيل طلب التصدير',
    orderInfoSection: 'معلومات الطلب',
    priceInfoSection: 'معلومات السعر',
    delivery: 'التوصيل',
    statusInfoSection: 'معلومات الحالة',
    orderedAt: 'تاريخ الطلب',
    canceledAt: 'تاريخ الإلغاء',
    canceledBy: 'أُلغي بواسطة',
    approvedAt: 'تاريخ الموافقة',
    approvedBy: 'تمت الموافقة بواسطة',
    refundedAt: 'تاريخ الاسترداد',
    refundedBy: 'تم الاسترداد بواسطة',
    sentAt: 'تاريخ الإرسال',
    receivedAt: 'تاريخ الاستلام',
    receivedBy: 'استُلم بواسطة',
    receiverInfoSection: 'معلومات المستلم',
    zipCode: 'الرمز البريدي',
    productDescription: 'وصف المنتج',
    receiverDetail: 'تفاصيل المستلم',
    destination: 'الوجهة',
    updateExportOrderTitle: 'تحديث طلب التصدير',
    addExportOrderTitle: 'إضافة طلب تصدير',
    requestExportOrderTitle: 'طلب تصدير',
    updateExportOrderTitleWithNumber: 'تحديث طلب التصدير {number}',
    requestedSuccessfullyMessage: 'تم الطلب بنجاح',
    requestButton: 'طلب',
    updateOrderTitleWithNumber: 'تحديث الطلب {number}',
    requestOrderTitle: 'طلب جديد',
    dimensionsPerPackageLabel: 'الأبعاد لكل طرد',
    cancelNote: 'ملاحظة الإلغاء',
    approveOrderTooltip: 'الموافقة على الطلب',
    volumeL: 'الحجم (طول)',
    volumeW: 'الحجم (عرض)',
    volumeH: 'الحجم (ارتفاع)',
    fullyRefundedBadge: 'مسترد بالكامل',
    partiallyRefundedBadge: 'مسترد جزئياً',
    partiallyRefundedAt: 'تاريخ الاسترداد الجزئي',
    partiallyRefundedBy: 'الاسترداد الجزئي بواسطة',
    totalRefundedAmount: 'إجمالي المبلغ المسترد',
    addingBalanceWithMethod: 'إضافة رصيد عبر {method}',
    addingBalanceFromOffice: 'إضافة رصيد من مكتب شيب زون',
    returningBalanceFromOffice: 'إرجاع رصيد من مكتب شيب زون',
    totalAddLabel: 'إجمالي الإضافة',
    totalCashBackLabel: 'إجمالي المسترجع',
    generalTotalLabel: 'الإجمالي العام',
    totalSubLabel: 'إجمالي الخصم',
    totalRefundLabel: 'إجمالي المسترد',
    orderNoHeading: 'رقم الطلب {id}',
    expectedDateLabel: 'التاريخ المتوقع',
    requestedStepLabel: 'مطلوب',
    deliveryStatusPrefix: 'التوصيل {status}',
    cannotUpdateTrackNumber: 'لا يمكنك تحديث رقم التتبع',
    addressIsRequired: 'العنوان مطلوب',
    orderRequestedSuccessfully: 'تم طلب الطلب بنجاح'
  },
  finance: {
    banksTitle: 'البنوك',
    addBankTitle: 'إضافة بنك',
    updateBankTitle: 'تحديث البنك',
    bankAddedSuccessfully: 'تمت إضافة البنك بنجاح',
    bankUpdatedSuccessfully: 'تم تحديث البنك بنجاح',
    filterByBank: 'تصفية حسب البنك',
    filterByStatus: 'تصفية حسب الحالة',
    filterByType: 'تصفية حسب النوع',
    bankTransactionsTitle: 'معاملات البنك',
    totalAmount: 'المبلغ الإجمالي',
    transactionDetailTitle: 'تفاصيل المعاملة',
    transactionInfoSection: 'معلومات المعاملة',
    classificationSection: 'التصنيف',
    sourceInfoSection: 'معلومات المصدر',
    datesAndStaffSection: 'التواريخ والموظف',
    couldNotUpdateVerificationStatus: 'تعذر تحديث حالة التحقق',
    pleaseSelectTransactionsToVerify: 'يرجى تحديد المعاملات للتحقق منها',
    verifySelectedTransactionsConfirm: 'التحقق من {count} معاملة محددة؟',
    transactionsVerifiedSuccessfully: 'تم التحقق من المعاملات بنجاح',
    pleaseTryAgain: 'يرجى المحاولة مرة أخرى',
    statusPaid: 'مدفوع',
    statusUnpaid: 'غير مدفوع',
    statusPending: 'قيد الانتظار',
    statusCancel: 'ملغى',
    statusRefunded: 'مسترد',
    statusPartialRefunded: 'مسترد جزئياً',
    typeOrder: 'طلب',
    typeMoneyTransfer: 'تحويل أموال',
    typeExpense: 'مصروف',
    typeCreditInvoice: 'فاتورة ائتمان',
    typeCashBack: 'استرداد نقدي',
    typeDigitalPayment: 'دفع رقمي',
    exchangeRatesTitle: 'أسعار الصرف',
    addExchangeRateTitle: 'إضافة سعر صرف',
    updateExchangeRateTitle: 'تحديث سعر الصرف',
    exchangeRateAddedSuccessfully: 'تمت إضافة سعر الصرف بنجاح',
    exchangeRateUpdatedSuccessfully: 'تم تحديث سعر الصرف بنجاح',
    currencyRatesTitle: 'أسعار العملات',
    addCurrencyRateTitle: 'إضافة سعر عملة جديد',
    updateCurrencyRateTitle: 'تحديث سعر العملة',
    sellRateLabel: 'سعر بيع {code} ({code} مقابل 1 دولار)',
    buyRateLabel: 'سعر شراء {code} (سعر البنك)',
    expensesTitle: 'المصروفات',
    addExpenseTitle: 'إضافة مصروف جديد',
    updateExpenseTitle: 'تحديث المصروف',
    thereIsAnError: 'يوجد خطأ',
    expenseFooterNote: 'كل سطر يمثل حالة مصروف واحدة (مجموع <strong>جميع</strong> الصفوف المطابقة، لكل الصفحات). الجدول أعلاه يعرض الصفحة الحالية فقط — استخدم الترقيم أو ارفع "لكل صفحة" لرؤية صفوف غير المدفوع/النقدي. اجمع المدفوع + غير المدفوع + النقدي ليطابق "المصروفات" في رأس المال عندما يتطابق النطاق الزمني مع فترة دفتر رأس المال.',
    received: 'مستلم',
    notReceived: 'غير مستلم',
    pleaseSelectAtLeastOneExpense: 'يرجى تحديد مصروف واحد على الأقل!',
    markAllSelectedExpensesReceivedConfirm: 'سيؤدي هذا إلى تعليم جميع المصروفات المحددة كمستلمة.',
    somethingWentWrong: 'حدث خطأ ما!',
    supplierInvoiceNumberLabel: 'رقم فاتورة المورد',
    expenseTypesTitle: 'أنواع المصروفات',
    addExpenseTypeTitle: 'إضافة نوع مصروف جديد',
    updateExpenseTypeTitle: 'تحديث نوع المصروف',
    capitalTitle: 'رأس المال',
    refresh: 'تحديث',
    initializeCapital: 'تهيئة رأس المال',
    depositWithdraw: 'إيداع / سحب',
    bookSummary: 'ملخص الدفتر ({from} إلى {to})',
    initializedCapital: 'رأس المال المهيأ',
    totalDeposits: 'إجمالي الإيداعات',
    totalWithdraws: 'إجمالي السحوبات',
    revenueIncome: 'الإيرادات (الدخل)',
    netCapitalBook: 'صافي رأس المال (الدفتر): {amount}',
    capitalMovements: 'حركات رأس المال',
    withdraw: 'سحب',
    deposit: 'إيداع',
    saved: 'تم الحفظ',
    couldNotSave: 'تعذر الحفظ',
    amountUsdLabel: 'المبلغ (دولار) *',
    depositOrWithdrawTitle: 'إيداع أو سحب',
    adjustsCapitalBookNote: 'يعدّل دفتر رأس المال فقط. أرصدة البنوك في النظام لا تتغير.',
    noteOptionalLabel: 'ملاحظة (اختياري)',
    noteReasonPlaceholder: 'سبب أو مرجع لهذه الحركة',
    noteShownHint: 'إذا تم إدخالها، ستظهر في قائمة الحركات.',
    depositAddToCapitalBook: 'إيداع (إضافة إلى دفتر رأس المال)',
    withdrawSubtractFromCapitalBook: 'سحب (خصم من دفتر رأس المال)',
    enterValidAmountError: 'أدخل مبلغاً صحيحاً (0.01 على الأقل).',
    moneyTransfersTitle: 'تحويلات الأموال',
    transferMoneyTitle: 'تحويل الأموال',
    doneSuccessfully: 'تم بنجاح'
  },
  login: {
    brandName: 'Las Shopping',
    welcomeBack: 'مرحباً بعودتك!',
    signInToContinue: 'سجّل الدخول للمتابعة',
    phoneNumber: 'رقم الهاتف',
    password: 'كلمة المرور',
    loginButton: 'تسجيل الدخول',
    noAccount: 'ليس لديك حساب؟',
    signUp: 'إنشاء حساب',
    adminLoginTitle: 'تسجيل دخول المسؤول',
    adminSignInSubtitle: 'سجّل الدخول إلى حساب الموظف',
    email: 'البريد الإلكتروني'
  },
  signup: {
    createAccountTitle: 'إنشاء حساب',
    step1Hint: 'أدخل رقم هاتفك لاستلام رمز التحقق.',
    sendCodeButton: 'إرسال الرمز',
    alreadyHaveAccount: 'لديك حساب بالفعل؟',
    signInLink: 'تسجيل الدخول',
    otpSentHintPrefix: 'أدخل رمز التحقق المُرسل إلى',
    verificationCodeLabel: 'رمز التحقق',
    backButton: '← رجوع',
    verifyButton: 'تحقق',
    step3Hint: 'أكمل ملفك الشخصي لإنهاء التسجيل.',
    fullNameHint: 'أدخل الاسم الأول والأخير على الأقل',
    dateOfBirthLabel: 'تاريخ الميلاد',
    passwordMinCharsHint: 'الحد الأدنى 6 أحرف',
    emailOptionalLabel: 'البريد الإلكتروني (اختياري)',
    genderOptionalLabel: 'الجنس (اختياري)',
    maleOption: 'ذكر',
    femaleOption: 'أنثى',
    deliveryAddressOptional: 'عنوان التوصيل',
    optionalLabel: '(اختياري)',
    addressSectionHint: 'يساعد على تسريع الطلبات المستقبلية',
    addressTypeLabel: 'نوع العنوان',
    houseNumberLabel: 'رقم المنزل',
    floorOptionalLabel: 'الطابق (اختياري)',
    streetLabel: 'الشارع',
    buildingNameLabel: 'اسم المبنى',
    apartmentNumberLabel: 'رقم الشقة',
    floorLabel: 'الطابق',
    companyLabel: 'الشركة',
    addressPhoneNumberOptional: 'رقم هاتف العنوان (اختياري)',
    additionalDirectionsOptional: 'توجيهات إضافية (اختياري)',
    addressLabelHint: 'تسمية العنوان (مثال: المنزل، العمل)',
    createAccountButton: 'إنشاء حساب',
    houseType: 'منزل',
    apartmentType: 'شقة',
    officeType: 'مكتب',
    validPhoneRequiredError: 'يرجى إدخال رقم هاتف صحيح',
    failedToSendCodeError: 'فشل إرسال الرمز',
    verificationCodeRequiredError: 'يرجى إدخال رمز التحقق',
    verificationFailedError: 'فشل التحقق',
    fullNameRequiredError: 'الاسم الكامل مطلوب',
    dobRequiredError: 'تاريخ الميلاد مطلوب',
    passwordMinLengthError: 'يجب أن تتكون كلمة المرور من 6 أحرف على الأقل',
    confirmPasswordRequiredError: 'يرجى تأكيد كلمة المرور',
    passwordsDoNotMatchError: 'كلمتا المرور غير متطابقتين',
    validEmailRequiredError: 'يرجى إدخال بريد إلكتروني صحيح',
    addressTypeRequiredError: 'نوع العنوان مطلوب',
    addressLabelRequiredError: 'تسمية العنوان مطلوبة (مثال: المنزل)',
    welcomeTitle: 'مرحباً!',
    accountCreatedSuccessfully: 'تم إنشاء حسابك بنجاح.',
    registrationFailedTitle: 'فشل التسجيل',
    verifyAccountTitle: 'تحقق من حسابك',
    nextButton: 'التالي',
    congratulationsTitle: 'تهانينا!',
    accountVerifiedSuccessfully: 'تم التحقق من حسابك بنجاح.',
    backToHomeButton: 'العودة إلى الرئيسية'
  },
  statistics: {
    fromDateLabel: 'من تاريخ',
    toDateLabel: 'إلى تاريخ',
    chartTypeLabel: 'نوع الرسم البياني',
    barChartOption: 'رسم بياني شريطي',
    pieChartOption: 'رسم بياني دائري',
    doughnutChartOption: 'رسم بياني حلقي',
    lineChartOption: 'رسم بياني خطي',
    applyButton: 'تطبيق',
    loadingStatisticsText: 'جارٍ تحميل الإحصائيات...',
    selectDateRangeHint: 'حدد نطاقاً زمنياً واضغط تطبيق لتحميل الرسوم البيانية.',
    noDataFoundHint: 'لم يتم العثور على بيانات للنطاق الزمني المحدد.',
    fullScreenTitle: 'ملء الشاشة',
    topCustomersByOrderCount: 'أفضل 10 عملاء حسب عدد الطلبات',
    topCustomersByRevenue: 'أفضل 10 عملاء حسب الإيرادات ($)',
    revenueUsdLabel: 'الإيرادات ($)',
    topWebsitesByOrders: 'أفضل 10 مواقع حسب الطلبات',
    topWarehousesByOrders: 'أفضل 10 مستودعات حسب الطلبات',
    topProductsByOrders: 'أفضل 10 منتجات حسب الطلبات',
    topBrandsByOrders: 'أفضل 10 علامات تجارية حسب الطلبات',
    orderStatusDistribution: 'توزيع حالة الطلبات',
    topItemTypesByOrders: 'أفضل 10 أنواع عناصر حسب الطلبات',
    monthlyOrderTrend: 'اتجاه الطلبات الشهري',
    pleaseSelectFromToDate: 'يرجى تحديد تاريخ البدء وتاريخ الانتهاء.',
    failedToLoadStatistics: 'فشل تحميل الإحصائيات.'
  },
  linkRules: {
    updateLinkRuleTitle: 'تحديث قاعدة الرابط',
    addNewLinkRuleTitle: 'إضافة قاعدة رابط جديدة',
    nameHint: "تسمية إدارية، مثال: 'Trendyol'",
    testUrlLabel: 'رابط اختباري',
    testUrlHint: 'ألصق رابط منتج حقيقي من هذا الموقع. يتم اشتقاق النطاق والمعاينة أدناه منه.',
    domainHint: 'يُطابق كجزء نصي مقابل مضيف الرابط، مثال: trendyol.com',
    shortLinkCheckboxLabel: 'هذا رابط مختصر (يُعيد التوجيه، مثال: ty.gl)',
    searchByNameOrDomainPlaceholder: 'البحث بالاسم أو النطاق...',
    shortLinkColumn: 'الرابط المختصر',
    priorityColumn: 'الأولوية',
    resolveButton: 'حل الرابط',
    resolvesToLabel: 'يؤدي إلى:',
    detectedAsProductPage: '✅ تم اكتشافها كصفحة منتج',
    notDetectedAsProductPage: '❌ لم يتم اكتشافها كصفحة منتج',
    previewExtractedNameLabel: 'معاينة الاسم المستخرج:',
    hideAdvancedOptions: 'إخفاء الخيارات المتقدمة',
    advancedOptionsHint: 'خيارات متقدمة (مطلوبة فقط إذا كانت المعاينة أعلاه غير صحيحة)',
    productPageMatchTypeLabel: 'نوع مطابقة صفحة المنتج',
    productPagePatternLabel: 'نمط صفحة المنتج',
    productPagePatternHint: 'جزء نصي من المسار (يحتوي على) أو تعبير نمطي',
    excludePathPrefixesLabel: 'استثناء بادئات المسار',
    excludePathPrefixesHint: 'مفصولة بفواصل، تتجاوز قائمة الاستثناء الافتراضية (سلة/دفع/إلخ) لهذا النطاق',
    nameExtractionTypeLabel: 'نوع استخراج الاسم',
    nameExtractionPatternLabel: 'نمط استخراج الاسم',
    nameExtractionPatternHint: 'تعبير نمطي بمجموعة التقاط واحدة، أو مفتاح معامل استعلام',
    nameCleanupRegexLabel: 'تعبير نمطي لتنظيف الاسم',
    nameCleanupRegexHint: 'اختياري: مزيل لاحقة إضافي يُطبق بعد الاستخراج',
    priorityLabel: 'الأولوية',
    priorityHint: 'الأقل يعمل أولاً عند إمكانية تطابق عدة قواعد',
    notesLabel: 'ملاحظات',
    containsPathSubstringOption: 'يحتوي (جزء من المسار)',
    regexOption: 'تعبير نمطي',
    regexCaptureGroupOption: 'تعبير نمطي (مجموعة التقاط 1)',
    queryParameterOption: 'معامل استعلام',
    couldNotResolveUrl: 'تعذر حل هذا الرابط'
  },
  qrLabels: {
    driverLabel: 'السائق',
    productLabel: 'المنتج',
    printLabelDriverButton: 'طباعة الملصق (السائق)',
    printLabelOrderIdButton: 'طباعة الملصق (رقم الطلب)',
    failedToGenerateQrCode: 'فشل إنشاء رمز QR',
    failedToAdvanceToIntShipment: 'فشل نقل الطلبات إلى الشحن الدولي'
  },
  datatable: {
    newOrderButton: 'طلب جديد',
    reloadTableButton: 'إعادة تحميل الجدول',
    toggleButtonDisplayTooltip: 'إظهار/إخفاء أسماء الأزرار',
    exportButton: 'تصدير',
    prepareToPrintButton: 'تجهيز للطباعة',
    fastPaymentButton: 'دفع سريع',
    mergeAndPrintButton: 'دمج وطباعة',
    receiveButton: 'استلام',
    unreceiveButton: 'إلغاء الاستلام',
    printReceiveButton: 'طباعة الاستلام',
    outOfficeButton: 'خارج المكتب',
    addNewButton: 'إضافة جديد',
    generateQrCodeButton: 'إنشاء رمز QR',
    generateInvoiceButton: 'إنشاء فاتورة',
    attachToDeliveryButton: 'إرفاق بالتوصيل',
    changeStatusButton: 'تغيير الحالة',
    deliverySummaryButton: 'ملخص التوصيل',
    unclearButton: 'إلغاء التصفية',
    reloadShortLabel: 'تحديث',
    qrCodeShortLabel: 'رمز QR',
    invoiceShortLabel: 'فاتورة',
    statusShortLabel: 'الحالة',
    summaryShortLabel: 'التوصيل',
    prepareToPrintShortLabel: 'طباعة',
    fastPaymentShortLabel: 'دفع سريع',
    mergeAndPrintShortLabel: 'دمج',
    printReceiveShortLabel: 'طباعة الاستلام',
    sendAllToCustomerShortLabel: 'إرسال الكل',
    secondInvoiceShortLabel: 'الفاتورة 2',
    generateSecondInvoiceButton: 'إنشاء الفاتورة الثانية',
    deliveryInvoiceButton: 'فاتورة التوصيل',
    sendToWarehouseButton: 'إرسال إلى المستودع',
    sendToPendingShipmentButton: 'إرسال إلى الشحن المعلق',
    sendAllToPendingShipmentButton: 'إرسال الكل إلى الشحن المعلق',
    sendToShipmentButton: 'إرسال إلى الشحن',
    sendAllToShipmentButton: 'إرسال الكل إلى الشحن',
    newShiponlyButton: 'شحن فقط جديد',
    sendToPendingToBranchButton: 'إرسال إلى الفرع المعلق',
    sendToBranchButton: 'إرسال إلى الفرع',
    sendAllToBranchButton: 'إرسال الكل إلى الفرع',
    sendToBranchDeliveryButton: 'إرسال إلى توصيل الفرع',
    sendToCustomerButton: 'إرسال إلى العميل',
    sendAllToCustomerButton: 'إرسال الكل إلى العميل',
    addStaffButton: 'إضافة موظف',
    approveAllShiponlyButton: 'الموافقة على كل الشحن فقط',
    bulkOrdersButton: 'طلبات بالجملة',
    sendAllToProcessButton: 'إرسال الكل للمعالجة',
    cashBackButton: 'استرداد نقدي',
    addCreditButton: 'إضافة رصيد',
    addWarehouseButton: 'إضافة مستودع',
    addCustomerButton: 'إضافة عميل',
    generateCouponButton: 'إنشاء كوبون',
    addBankButton: 'إضافة بنك',
    addSupplierButton: 'إضافة مورد',
    addExpenseTypeButton: 'إضافة نوع مصروف',
    addNewExpenseButton: 'إضافة مصروف جديد',
    addNewCityButton: 'إضافة مدينة جديدة',
    updateCityTitle: 'تحديث المدينة',
    updateAboutTitle: 'تحديث حول التطبيق',
    addNewAboutTitle: 'إضافة حول التطبيق جديد',
    updateSupplierTitle: 'تحديث المورد',
    addNewSupplierTitle: 'إضافة مورد جديد',
    addGovernorateButton: 'إضافة محافظة',
    addNewReasonButton: 'إضافة سبب جديد',
    updateReasonTitle: 'تحديث السبب',
    addNewAboutAppButton: 'إضافة معلومات جديدة عن التطبيق',
    addNewHelpCenterButton: 'إضافة مركز مساعدة جديد',
    addNewRoleButton: 'إضافة دور جديد',
    updateRoleTitle: 'تحديث الدور',
    deleteSelectedSubscriptionButton: 'حذف الاشتراك المحدد',
    addNewCustomerSubscriptionButton: 'إضافة اشتراك عميل جديد',
    permanentlyDeleteSelectedOrdersButton: 'حذف الطلبات المحددة نهائياً',
    addNewBranchButton: 'إضافة فرع جديد',
    branchesTitle: 'الفروع',
    updateBranchTitle: 'تحديث الفرع',
    addMoneyButtonDefault: 'إضافة رصيد',
    transferMoneyButton: 'تحويل أموال',
    addExchangeRateButton: 'إضافة سعر صرف',
    requestDeliveryButton: 'طلب توصيل',
    applyFilterTooltip: 'تطبيق التصفية',
    cancelFilterTooltip: 'إلغاء التصفية',
    showHideColumnsLabel: 'إظهار/إخفاء الأعمدة',
    pleaseSelectWarehouseHint: 'يرجى اختيار المستودع',
    pleaseSelectBothDatesError: 'يرجى تحديد كلا التاريخين!',
    chooseOption: 'اختر',
    orderOption: 'الطلب',
    usaOption: 'أمريكا',
    chinaOption: 'الصين',
    uaeOption: 'الإمارات',
    partialReceivedOption: 'مستلم جزئياً'
  },
  printLogs: {
    title: 'سجلات الطباعة',
    subtitle: 'تتبع جميع الفواتير المطبوعة',
    printButton: 'طباعة',
    printAllButton: 'طباعة الكل',
    fromLabel: 'من',
    toLabel: 'إلى',
    typeLabel: 'النوع',
    allTypesOption: 'كل الأنواع',
    secondShippingOption: 'الشحن الثاني',
    printedByLabel: 'طُبعت بواسطة',
    allStaffOption: 'كل الموظفين',
    filterButton: 'تصفية',
    todayButton: 'اليوم',
    totalEntries: 'إجمالي السجلات',
    totalAmountLabel: 'إجمالي المبلغ',
    firstPrints: 'الطبعات الأولى',
    reprints: 'إعادة الطباعة',
    loadingLogsText: 'جارٍ تحميل السجلات...',
    noPrintsFoundTitle: 'لا توجد طبعات',
    noPrintsFoundBetween: 'لم تتم طباعة أي فواتير بين {from} و {to}.',
    timeColumn: 'الوقت',
    reprintBadge: 'إعادة طباعة ×{count}',
    firstPrintBadge: 'الطبعة الأولى',
    viewOnlyBadge: 'للعرض فقط',
    viewOnlyTooltip: 'طُبعت من زر عرض الفاتورة — ليست إثباتاً للدفع',
    deliveryPrintTooltip: 'طُبعت عبر زر التوصيل — مرفقة بطلب توصيل العميل',
    saveAndViewBadge: 'حفظ وعرض',
    saveAndViewTooltip: 'طُبعت عبر حفظ وعرض — نسخة رسمية من الفاتورة المحفوظة',
    totalLabel: 'الإجمالي',
    printPageTitle: 'سجلات الطباعة — {from} إلى {to}'
  },
  profit: {
    title: 'الأرباح',
    totalInternationalShipment: 'إجمالي الشحن الدولي',
    totalShippingInvoiceShipment: 'إجمالي شحن فاتورة الشحن',
    totalLocalTax: 'إجمالي الضريبة المحلية',
    totalFee: 'إجمالي الرسوم',
    totalRefund: 'إجمالي المسترد',
    totalIncome: 'إجمالي الدخل',
    totalExpense: 'إجمالي المصروفات'
  },
  driverDeliver: {
    loadingOrderDetails: 'جاري تحميل تفاصيل الطلب...',
    orderMovedTitle: 'تم نقل الطلب إلى توصيل الفرع!',
    orderMovedMessage: 'تم نقل الطلب رقم {id} إلى توصيل الفرع.',
    alreadyAtBranchTitle: 'موجود بالفعل في الفرع',
    alreadyAtBranchMessage: 'تم نقل هذا الطلب بالفعل إلى توصيل الفرع.',
    cannotProcessTitle: 'لا يمكن المعالجة',
    wrongStatusMessage: 'هذا الطلب ليس في مرحلة الشحن الدولي. الحالة الحالية:',
    orderNumberLabel: 'الطلب رقم {id}',
    naLabel: 'غير متوفر',
    areaLabel: 'المنطقة',
    houseBuildingLabel: 'المنزل / المبنى',
    deliveryPhoneLabel: 'هاتف التوصيل',
    tapToMoveButton: 'اضغط للنقل إلى توصيل الفرع',
    processingButton: 'جارٍ المعالجة...',
    unknownStatus: 'غير معروف',
    failedToLoadOrder: 'فشل تحميل الطلب',
    failedToLoadOrderDetails: 'فشل تحميل تفاصيل الطلب',
    failedToProcessOrder: 'فشل معالجة الطلب'
  },
  addEditGovernorate: {
    updateTitle: 'تحديث المحافظة',
    addTitle: 'إضافة محافظة جديدة',
    governorateNameLabel: 'اسم المحافظة',
    governorateNameArLabel: 'اسم المحافظة (عربي)',
    governorateNameKuLabel: 'اسم المحافظة (كردي)'
  },
  cashBack: {
    title: 'استرداد نقدي للرصيد',
    cashedBackSuccessfully: 'تم استرداد الرصيد نقدًا بنجاح',
    amountMoreThanCreditError: 'مبلغ الاسترداد النقدي أكبر من رصيد العميل',
    editTitle: 'تعديل الاسترداد النقدي',
    updatedSuccessfully: 'تم تحديث الاسترداد النقدي بنجاح'
  },
  generateCoupon: {
    couponsGeneratedSuccessfully: 'تم إنشاء الكوبونات بنجاح',
    couponsUpdatedSuccessfully: 'تم تحديث الكوبونات بنجاح',
    numberOfCouponLabel: 'عدد الكوبونات',
    discountPercentageLabel: 'نسبة الخصم',
    expireDateLabel: 'تاريخ الانتهاء',
    generateButton: 'إنشاء',
    pleaseDetermineExpireDate: 'يرجى تحديد تاريخ الانتهاء',
    expireDateMustBeGreaterThanToday: 'يجب أن يكون تاريخ الانتهاء أكبر من اليوم'
  },
  partialRefundingOrder: {
    title: 'استرداد جزئي',
    orderTotalAmountLabel: 'إجمالي مبلغ الطلب هو ${amount}'
  },
  addEditOrderCase: {
    updateTitle: 'تحديث حالة الطلب',
    addTitle: 'إضافة حالة طلب جديدة',
    orderIdColon: 'رقم الطلب:',
    imagesTitle: 'صور حالة الطلب'
  },
  addEditNotFoundOrder: {
    updateTitle: 'تحديث الطلب غير الموجود',
    addTitle: 'إضافة طلب غير موجود جديد',
    updatedTitle: 'تم التحديث'
  },
  adminCancelOrder: {
    orderCanceledSuccessfully: 'تم إلغاء الطلب بنجاح',
    willAutoRefundPrefix: 'تم شراء هذا الطلب بالفعل. سيؤدي إلغاؤه أيضًا إلى إصدار استرداد كامل تلقائيًا',
    ofUpToAmount: ' يصل إلى ${amount}',
    willAutoRefundTail: ' إلى رصيد ائتمان العميل. سيأخذ المبلغ الدقيق بعين الاعتبار أي عمليات استرداد جزئية سابقة تم منحها.',
    cancelReasonListLabel: 'قائمة أسباب الإلغاء',
    cancelReasonEnglishLabel: 'سبب الإلغاء بالإنجليزية',
    cancelReasonArabicLabel: 'سبب الإلغاء بالعربية',
    cancelReasonKurdishLabel: 'سبب الإلغاء بالكردية'
  },
  globalWebsiteGroupModal: {
    updateGroupTitle: 'تحديث المجموعة',
    addNewGroupTitle: 'إضافة مجموعة جديدة',
    sitesButton: 'المواقع'
  },
  recordInvoicePayment: {
    title: 'تسجيل الدفع',
    invoiceHashLabel: 'رقم الفاتورة #',
    walletBalanceCheckboxLabel: 'العميل لديه بالفعل هذا المبلغ في رصيد محفظته (مثلاً من شحن FIB/QI/المكتب) — طبّقه بدون إضافة رصيد مرة أخرى',
    balanceOption: 'الرصيد',
    availableTitle: 'لدى هذا العميل رصيد متاح بقيمة {amount}',
    useBalance: 'استخدم الرصيد',
    unknownSource: 'مصدر غير محدد',
    balanceHint: '"الرصيد" لا يضيف مالاً أبداً — يدفع مما لدى العميل بالفعل.',
    balanceButton: 'الرصيد',
    payButton: 'ادفع'
  },
  addEditUserSubscription: {
    customerSubscriptionTitle: 'اشتراك العميل',
    deleteAllSelectedConfirm: 'هل تريد حذف جميع اشتراكات المستخدمين المحددة؟'
  },
  orderDeliveryCustomerImages: {
    title: 'طلبات وصور العميل',
    noOrdersFound: 'لا توجد طلبات لهذا العميل.',
    productLabel: 'المنتج',
    imagesLabel: 'الصور',
    notInvoiced: 'غير مفوتر'
  },
  viewOrderDates: {
    pendingAnswerDateLabel: 'تاريخ انتظار الرد',
    processDateLabel: 'تاريخ المعالجة',
    cancelDateLabel: 'تاريخ الإلغاء',
    approveDateLabel: 'تاريخ الموافقة',
    refundDateLabel: 'تاريخ الاسترداد',
    pendingShipmentDateLabel: 'تاريخ الشحن المعلق',
    shipmentDateLabel: 'تاريخ الشحن',
    deliveredDateLabel: 'تاريخ التسليم'
  },
  refundingOrder: {
    title: 'استرداد الطلب',
    sendSmsLabel: 'إرسال رسالة نصية',
    orderTotalRemainAmountLabel: 'المبلغ المتبقي الإجمالي للطلب هو ${amount}'
  },
  assignPermission: {
    titleWithRole: 'تعيين صلاحية لدور [{role}]',
    savedSuccessfully: 'تم الحفظ بنجاح',
    checkAllLabel: 'تحديد الكل'
  },
  purchaseOrder: {
    titleWithId: 'شراء الطلب {id}',
    costBreakdownByWarehouse: 'تفصيل التكلفة حسب المستودع',
    ordersSelectedLabel: 'تم تحديد {count} طلب',
    actualPriceLabel: 'السعر الفعلي',
    actualPriceRequiredError: 'السعر الفعلي مطلوب',
    mustBeValidNumberError: 'يجب أن يكون رقمًا صحيحًا'
  },
  reassignCustomer: {
    reassignCustomerTooltip: 'إعادة تعيين العميل',
    chargedToLabel: 'هذا الطلب مُحمَّل حاليًا على',
    pickingDifferentCustomerText: 'اختيار عميل مختلف أدناه سيؤدي إلى استرداد المبلغ لـ {name}، وحذف فاتورة الشحن لهذا الطلب، وتحصيل فاتورة جديدة من العميل المحدد بنفس المبلغ (${amount}).',
    newCustomerLabel: 'العميل الجديد* (ابحث بالاسم أو رقم الهاتف)',
    telPrefix: ' - هاتف: ',
    failedToLoadCustomers: 'فشل تحميل العملاء',
    selectedCustomerFallback: 'العميل المحدد',
    confirmReassignText: 'سيؤدي هذا إلى استرداد المبلغ لـ {name}، وحذف فاتورة الشحن لهذا الطلب، وتحصيل فاتورة جديدة من {newName} بمبلغ ${amount}. هل تريد المتابعة؟',
    failedToReassignCustomer: 'فشل إعادة تعيين العميل'
  },
  createCredit: {
    creditAddedSuccessfully: 'تمت إضافة الرصيد بنجاح',
    amountUsdLabel: 'المبلغ بالدولار',
    amountIqdLabel: 'المبلغ بالدينار العراقي',
    autoInvoiceLabel: 'إنشاء فاتورة تلقائيًا للطلبات المشحونة التي ليس لها فاتورة بعد (إلغاء التحديد يتخطى فقط إنشاء فاتورة جديدة — هذا الشحن سيظل يسدد أي فاتورة موجودة مسبقًا على أي حال)'
  },
  helpCenter: {
    updateTitle: 'تحديث مركز المساعدة',
    questionEnLabel: 'السؤال (إنجليزي)',
    questionArLabel: 'السؤال (عربي)',
    questionKuLabel: 'السؤال (كردي)',
    answerEnLabel: 'الإجابة (إنجليزي)',
    answerArLabel: 'الإجابة (عربي)',
    answerKuLabel: 'الإجابة (كردي)',
    isActiveLabel: 'نشط',
    answerEnRequiredError: 'الإجابة (إنجليزي) مطلوبة',
    displayLanguageLabel: 'لغة العرض',
    englishEnOption: 'الإنجليزية (en)',
    arabicArOption: 'العربية (ar)',
    kurdishKuOption: 'الكردية (ku)'
  },
  processExportOrder: {
    title: 'معالجة طلب التصدير',
    orderNoColon: 'رقم الطلب:'
  },
  customerDeliverySummary: {
    title: 'ملخص توصيل العملاء',
    clearButton: 'مسح',
    loadingAllOrders: 'جاري تحميل جميع الطلبات المطابقة…',
    totalCustomerLabel: 'إجمالي العملاء',
    totalOrdersLabel: 'إجمالي الطلبات',
    requestReceivedLabel: 'الطلبات المستلمة',
    dateReceivedLabel: 'تاريخ الاستلام',
    timeLabel: 'الوقت',
    confirmClearOrdersText: 'وضع علامة على {count} طلب كمُسوّى؟ لن يظهر بعد الآن في هذه القائمة افتراضيًا.',
    failedToClearOrders: 'فشل مسح الطلبات'
  },
  adminDashboard: {
    title: 'لوحة التحكم',
    updatedAtLabel: 'تم التحديث {time}',
    refreshButton: 'تحديث',
    loadingDashboardText: 'جاري تحميل لوحة التحكم...',
    orderIntakeSection: 'استلام الطلبات',
    processingSection: 'قيد المعالجة',
    fulfillmentSection: 'التنفيذ',
    deliveryCompletionSection: 'التوصيل والإكمال',
    pendingAnswerLabel: 'بانتظار الرد',
    processedLabel: 'تمت المعالجة',
    ordersTodayLabel: 'طلبات اليوم',
    pendingPaymentsLabel: 'مدفوعات معلقة',
    purchasedLabel: 'تم الشراء',
    warehouseDeliveredLabel: 'تم التسليم للمستودع',
    intShipmentLabel: 'الشحن الدولي',
    pendingToBranchLabel: 'بانتظار التحويل للفرع',
    branchDeliveryLabel: 'توصيل الفرع',
    deliveredLabel: 'تم التسليم',
    kurdistanBalance: 'رصيد كردستان',
    usaBalance: 'رصيد أمريكا',
    customersOweUs: 'العملاء مدينون لنا',
    weOweCustomers: 'نحن مدينون للعملاء',
    supplierLoan: 'قرض المورد',
    totalCapital: 'إجمالي رأس المال'
  },
  homeSlider: {
    updateTitle: 'تحديث السلايدر الرئيسي',
    addTitle: 'إضافة سلايدر رئيسي جديد'
  },
  editOrderCharge: {
    editChargeTooltip: 'تعديل الرسوم',
    editChargeTitle: 'تعديل الرسوم',
    alreadyChargedHint: 'تم تحصيل هذا الطلب بالفعل. سيؤدي تغيير الإجمالي أدناه تلقائيًا إلى خصم أو إضافة الفرق من/إلى رصيد العميل.',
    itemPriceUsdLabel: 'سعر الصنف ($)',
    shippingUsdLabel: 'الشحن ($)',
    discountUsdLabel: 'الخصم ($)',
    newTotalLabel: 'الإجمالي الجديد:',
    wasLabel: '(كان ${amount})',
    failedToLoadOrderDetails: 'فشل تحميل تفاصيل الطلب',
    increaseWithBalanceText: 'سيزيد الإجمالي من ${from} إلى ${to} (+${diff}). سيتم خصم ${diff} من رصيد العميل. هل تريد المتابعة؟',
    increaseInsufficientBalanceText: 'سيزيد الإجمالي من ${from} إلى ${to} (+${diff}). قد يكون رصيد العميل غير كافٍ — سيتم تسجيل ملاحظة بدلاً من ذلك. هل تريد المتابعة؟',
    decreaseText: 'سينخفض الإجمالي من ${from} إلى ${to} (-${diff}). سيتم إضافة ${diff} إلى رصيد العميل. هل تريد المتابعة؟',
    orderUpdatedTitle: 'تم تحديث الطلب',
    failedToUpdateOrder: 'فشل تحديث الطلب'
  },
  refundExportOrder: {
    fullRefundTitle: 'استرداد كامل لطلب التصدير',
    partialRefundTitle: 'استرداد جزئي لطلب التصدير',
    refundedSuccessfully: 'تم استرداد الطلب بنجاح',
    orderTotalAmountLabel: 'إجمالي مبلغ الطلب هو ${amount}',
    alreadyRefundedLabel: 'المسترد مسبقًا: ${amount}',
    moneyAmountLabel: 'مبلغ المال',
    refundNoteLabel: 'ملاحظة الاسترداد',
    confirmRefundText: 'سيتم استرداد ${amount} إلى رصيد العميل.',
    validRefundAmountError: 'يرجى إدخال مبلغ استرداد صحيح',
    amountExceedsRemainingError: 'لا يمكن أن يتجاوز المبلغ المتبقي: ${amount}',
    partialLessThanRemainingError: 'يجب أن يكون الاسترداد الجزئي أقل من المبلغ المتبقي: ${amount}',
    refundReasonRequiredError: 'سبب الاسترداد مطلوب للاسترداد الكامل',
    fullRefundProcessedSuccessfully: 'تمت معالجة الاسترداد الكامل بنجاح',
    partialRefundProcessedSuccessfully: 'تمت معالجة الاسترداد الجزئي بنجاح',
    failedToProcessRefund: 'فشلت معالجة الاسترداد'
  },
  secret: {
    greetingHi: 'مرحباً {name}',
    enterSecretKeyHint: 'لرؤية هذا القسم يجب عليك إدخال المفتاح السري الخاص بك',
    dontHaveSecretKey: 'ليس لديك مفتاح سري؟',
    letMeInButton: 'دعني أدخل',
    confirmSecretKeyLabel: 'تأكيد المفتاح السري'
  },
  viewOrderUsers: {
    orderedBy: 'طُلب بواسطة',
    shipOnlyBy: 'شحن فقط بواسطة',
    pendingAnsweredBy: 'تم الرد عليه بواسطة',
    processedBy: 'تمت المعالجة بواسطة',
    warehousedBy: 'تم إدخاله للمستودع بواسطة',
    pendingShippedBy: 'شحن معلق بواسطة',
    shippedBy: 'تم الشحن بواسطة',
    pendingToBranchBy: 'قيد التحويل للفرع بواسطة',
    brandDeliveredBy: 'تم التسليم للفرع بواسطة',
    deliveredBy: 'تم التسليم بواسطة',
    archivedBy: 'تمت الأرشفة بواسطة'
  },
  home: {
    welcomeTitle: 'مرحبًا بك في Lasshopping',
    pleaseFillOutInfo: 'يرجى تعبئة هذه المعلومات',
    processWasSuccessful: 'تمت العملية بنجاح',
    realEmailHint: 'يجب أن يكون البريد الإلكتروني حقيقيًا، لأن جميع الإجراءات المتعلقة بطلبك سترسل إلى هذا البريد'
  },
  forceUpdate: {
    updateTitle: 'تحديث التحديث الإجباري',
    addTitle: 'إضافة تحديث إجباري جديد',
    minBuildNumberLabel: 'الحد الأدنى لرقم الإصدار المطلوب',
    minBuildNumberHint: 'أي تطبيق مثبت أقل من رقم الإصدار هذا سيُجبر على التحديث.',
    operatingSystemLabel: 'نظام التشغيل',
    imageMustBeImageError: 'يجب أن يكون نوع الملف صورة',
    minBuildNumberColumn: 'أقل رقم إصدار',
    softUpdateType: 'اختياري',
    hardUpdateType: 'إجباري'
  },
  editCredit: {
    title: 'تعديل الرصيد',
    updatedSuccessfully: 'تم تحديث الرصيد بنجاح'
  },
  addEditSubscription: {
    addTitle: 'إضافة اشتراك',
    addNewButton: 'إضافة اشتراك جديد',
    nameLabel: 'اسم الاشتراك',
    deleteSubscriptionConfirm: 'حذف الاشتراك: {name}؟',
    deleteUserSubscriptionConfirm: 'حذف اشتراك المستخدم: {name}؟'
  },
  addEditOrderType: {
    addTitle: 'إضافة نوع طلب',
    nameLabel: 'اسم النوع',
    addNewButton: 'إضافة نوع طلب جديد'
  },
  prepareToPrint: {
    arrivedDateLabel: 'تاريخ الوصول:',
    signatureLabel: 'التوقيع'
  },
  exportOrder: {
    cancelTitle: 'إلغاء طلب التصدير'
  },
  editTransportationType: {
    title: 'تعديل نوع النقل'
  },
  invoicePaymentLogs: {
    title: 'سجلات الدفع',
    paidAfterColumn: 'المدفوع بعد',
    remainingAfterColumn: 'المتبقي بعد',
    noPaymentsRecordedYet: 'لا توجد مدفوعات مسجلة بعد'
  },
  editProductName: {
    title: 'تعديل اسم المنتج',
    updatedSuccessfully: 'تم تحديث اسم المنتج بنجاح'
  },
  sendToWarehouse: {
    title: 'إرسال الطلب إلى المستودع'
  },
  sendToShipment: {
    title: 'إرسال الطلب إلى الشحن'
  },
  sendNotification: {
    title: 'إرسال إشعار',
    sendToAllLabel: 'إرسال للجميع',
    sendToDeliveredLabel: 'إرسال لعملاء الطلبات المسلّمة',
    selectCustomerLabel: 'اختر العميل',
    bodyLabel: 'المحتوى',
    historyTitle: 'المرسلة سابقًا',
    historyEmptyLabel: 'لم يتم إرسال أي إشعارات بعد',
    useAgainTooltip: 'استخدام هذه الرسالة',
    audienceAllLabel: 'جميع العملاء',
    audienceDeliveredOnlyLabel: 'عملاء الطلبات المسلّمة',
    audienceCustomSuffix: 'عميل',
    recipientsLabel: 'المستلمون'
  },
  ourAddress: {
    searchPlaceholder: 'بحث...',
    transByColumn: 'وسيلة النقل',
    ourAddressesTitle: 'عناويننا'
  },
  homeBanner: {
    isCounterLabel: 'عداد تنازلي',
    titleArabicLabel: 'العنوان بالعربية',
    titleKurdishLabel: 'العنوان بالكردية',
    descriptionArabicLabel: 'الوصف بالعربية',
    descriptionKurdishLabel: 'الوصف بالكردية',
    startDateLabel: 'تاريخ البدء',
    endDateLabel: 'تاريخ الانتهاء',
    colorDarkLabel: 'اللون الداكن',
    backgroundColorLabel: 'لون الخلفية',
    backgroundColorDarkLabel: 'لون الخلفية الداكن',
    titleRequiredError: 'العنوان مطلوب',
    titleArabicRequiredError: 'العنوان بالعربية مطلوب',
    titleKurdishRequiredError: 'العنوان بالكردية مطلوب',
    startDateRequiredError: 'تاريخ البدء مطلوب',
    endDateRequiredError: 'تاريخ الانتهاء مطلوب',
    endDateAfterStartDateError: 'يجب أن يكون تاريخ الانتهاء بعد تاريخ البدء',
    colorHexError: 'يجب أن يكون اللون رمز لون سداسي صالح',
    descriptionRequiredError: 'الوصف مطلوب',
    descriptionArabicRequiredError: 'الوصف بالعربية مطلوب',
    descriptionKurdishRequiredError: 'الوصف بالكردية مطلوب'
  },
  customerPrices: {
    updatedSuccessfully: 'تم تحديث أسعار العميل بنجاح',
    baseQttChargeUsaLabel: 'رسوم الكمية الأساسية (أمريكا)',
    otherQttChargeUsaLabel: 'رسوم الكمية الأخرى (أمريكا)'
  },
  kreenexFeePrices: {
    updatedSuccessfully: 'تم تحديث أسعار رسوم ShipZone بنجاح',
    feePercentageLabel: 'نسبة رسوم ShipZone',
    feeBaseUsaLabel: 'أساس رسوم ShipZone (أمريكا)',
    feeUsaLabel: 'رسوم ShipZone (أمريكا)',
    explanationInPrefix: 'في',
    explanationIfLessThan: 'إذا كان',
    explanationLessThan: 'أقل من',
    explanationWillBe: 'ستكون',
    explanationOtherwise: '، وإلا',
    explanationFormula: 'رسوم ShipZone (أمريكا) + (سعر القطعة × نسبة رسوم ShipZone)'
  },
  orderStatusSettings: {
    title: 'إعدادات حالة الطلب',
    description: 'أعد تسمية أو غيّر لون أو أخفِ أي حالة طلب. الحالة المخفية تختفي من قوائم اختيار الحالة والفلاتر والتنقل عبر لوحة الإدارة وموقع العملاء وتطبيق الجوال — منطق الحالة الأساسي (الانتقالات، الاستردادات، إلخ) يستمر بالعمل دون تغيير في كلتا الحالتين.',
    displayNameEnColumn: 'اسم العرض (إنجليزي)',
    displayNameArColumn: 'اسم العرض (عربي)',
    displayNameKuColumn: 'اسم العرض (كردي)',
    displayNameTrColumn: 'اسم العرض (تركي)',
    visibleColumn: 'ظاهر',
    egNewOrderPlaceholder: 'مثال: طلب جديد',
    failedToSaveOneOrMoreStatuses: 'فشل حفظ حالة واحدة أو أكثر'
  },
  changeOrderStatus: {
    title: 'تغيير حالة الطلب',
    ordersSelectedSuffix: 'طلب(ات) محددة',
    orderColonPrefix: 'الطلب:',
    alreadyPurchasedBeforeInfo: 'تم شراء هذا الطلب مسبقاً — سيتم نقله مباشرة إلى حالة تم الشراء، دون الحاجة لإعادة إدخال هذه التفاصيل.',
    actualPriceCalculatedAutomatically: 'سيتم حساب السعر الفعلي لكل طلب تلقائياً.',
    refundReasonRequiredLabel: 'سبب الاسترداد*',
    moneyAmountLabel: 'مبلغ المال',
    eachOrderRefundedFullRemaining: 'سيتم استرداد كامل المبلغ المتبقي لكل طلب.',
    savingLabel: 'جارٍ الحفظ...',
    unmarkOrdersAsClearedConfirm: 'إلغاء تحديد {count} طلب(ات) كمصفّاة؟ ستظهر مرة أخرى في هذه القائمة ضمن فلتر النشطة.',
    orderAlreadyHasInvoiceMessage: 'الطلب {orderId} لديه بالفعل فاتورة {status}{invoiceNumber}. المتابعة لن تعيد محاسبة العميل مرة أخرى. متابعة؟',
    ordersAlreadyHaveInvoiceMessage: 'الطلبات التالية لديها بالفعل فاتورة مدفوعة أو مدفوعة جزئياً:\n\n{lines}\n\nالمتابعة لن تعيد محاسبتهم مرة أخرى. متابعة؟',
    orderAlreadyPurchasedRefundWarning: 'تم شراء/شحن هذا الطلب بالفعل. سيؤدي إلغاؤه أيضاً إلى استرداد كامل تلقائي يصل إلى ${amount} للعميل.',
    statusLockedOrderCanceled: 'الحالة مقفلة — الطلب ملغى',
    clickToChangeStatus: 'اضغط لتغيير الحالة',
    failedToChangeOrderStatus: 'فشل تغيير حالة الطلب',
    ordersUpdatedSuccessfully: 'تم تحديث الطلبات بنجاح'
  },
  shipOnly: {
    orderNoteColumn: 'ملاحظة الطلب',
    whDateColumn: 'تاريخ المستودع',
    warehousePassedLabel: 'تجاوز موعد المستودع',
    warehouseDateChangedSuccessfully: 'تم تغيير تاريخ المستودع',
    orderPriceLabel: 'سعر الطلب',
    willPayOption: 'سيدفع',
    loanOption: 'دين',
    allOrdersApprovedAndPurchased: 'تمت الموافقة على جميع الطلبات المحددة وشراؤها.',
    goToCustomerCreditLink: 'الذهاب إلى رصيد العميل',
    addShipOnlyTitle: 'إضافة شحن فقط'
  },
  activityLog: {
    accountTypeLabel: 'نوع الحساب',
    allAccountsOption: 'جميع الحسابات',
    allPlatformsOption: 'جميع المنصات',
    adminWebOption: 'الإدارة (ويب)',
    mobileIosOption: 'الجوال (iOS)',
    mobileAndroidOption: 'الجوال (Android)',
    accountNameLabel: 'الحساب (الاسم)',
    searchStaffOrCustomerPlaceholder: 'البحث عن اسم موظف أو عميل',
    eventLabel: 'الحدث',
    eventPlaceholder: 'مثال: post, approved, login',
    subjectTypeLabel: 'نوع الموضوع',
    subjectTypePlaceholder: 'مثال: Order, Invoice',
    routeOrDescriptionPlaceholder: 'المسار أو الوصف',
    showingHistoryForPrefix: 'عرض السجل الخاص بـ',
    accountColumn: 'الحساب',
    guestLabel: 'زائر'
  },
  customerDeviceIcon: {
    orderedViaMobileApp: 'تم الطلب عبر تطبيق الجوال',
    orderedViaWeb: 'تم الطلب عبر الويب',
    addedByAdminStaff: 'أضيف بواسطة الإدارة/الموظف',
    unknownSourceLegacyOrder: 'مصدر غير معروف (طلب قديم)'
  },
  editBank: {
    title: 'تعديل البنك',
    loadingBanks: 'جاري تحميل البنوك...',
    selectBankLabel: 'اختر البنك'
  },
  editEntityField: {
    editTypeTitle: 'تعديل النوع',
    typeUpdatedSuccessfully: 'تم تحديث النوع بنجاح',
    editSizeTitle: 'تعديل الحجم',
    sizeUpdatedSuccessfully: 'تم تحديث الحجم بنجاح',
    editColorTitle: 'تعديل اللون',
    colorUpdatedSuccessfully: 'تم تحديث اللون بنجاح'
  },
  editPriceForCountry: {
    priceUpdatedSuccessfully: 'تم تحديث السعر بنجاح',
    pricePerWeightTurkeyLabel: 'سعر الوزن لتركيا',
    pricePerWeightUsaLabel: 'سعر الوزن لأمريكا'
  },
  editQuantity: {
    title: 'تعديل الكمية',
    updatedSuccessfully: 'تم تحديث الكمية بنجاح'
  },
  editQuantityCharge: {
    usaOtherLabel: 'رسوم الكمية الأخرى - أمريكا',
    usaOtherUpdatedSuccessfully: 'تم تحديث رسوم الكمية الأخرى - أمريكا بنجاح',
    turkeyOtherLabel: 'رسوم الكمية الأخرى - تركيا',
    turkeyOtherUpdatedSuccessfully: 'تم تحديث رسوم الكمية الأخرى - تركيا بنجاح',
    usaBaseLabel: 'رسوم الكمية الأساسية - أمريكا',
    usaBaseUpdatedSuccessfully: 'تم تحديث رسوم الكمية الأساسية - أمريكا بنجاح',
    turkeyBaseLabel: 'رسوم الكمية الأساسية - تركيا',
    turkeyBaseUpdatedSuccessfully: 'تم تحديث رسوم الكمية الأساسية - تركيا بنجاح'
  },
  giveToCustomer: {
    title: 'تعديل النسبة',
    givenSuccessfully: 'تم منح الكوبون للعميل بنجاح',
    giveButton: 'منح'
  },
  editProductUrl: {
    title: 'تعديل رابط المنتج',
    updatedSuccessfully: 'تم تحديث رابط المنتج بنجاح'
  },
  addRefundNumber: {
    title: 'إضافة رقم الاسترداد',
    addedSuccessfully: 'تمت إضافة رقم الاسترداد بنجاح'
  },
  mobileDatatable: {
    infoAndDateColumn: 'المعلومات والتاريخ',
    staffDetailColumn: 'تفاصيل الموظف',
    infoAndStatusColumn: 'المعلومات والحالة',
    customerDetailColumn: 'تفاصيل العميل',
    invoiceDetailColumn: 'تفاصيل الفاتورة',
    actionAndDateColumn: 'الإجراء والتاريخ',
    couponDetailColumn: 'تفاصيل الكوبون',
    statusAndDatesColumn: 'الحالة والتواريخ',
    customerAndDateColumn: 'العميل والتاريخ',
    staffAndCustomerColumn: 'الموظف والعميل',
    statusAndDateColumn: 'الحالة والتاريخ',
    rateDetailColumn: 'تفاصيل السعر',
    dateAndActionsColumn: 'التاريخ والإجراءات'
  },
  shippingPrices: {
    title: 'أسعار الشحن (تركيا)',
    updatedSuccessfully: 'تم تحديث أسعار الشحن بنجاح',
    pleaseUpdateAnythingError: 'يرجى تحديث أي شيء',
    addTypeButton: 'إضافة نوع'
  },
  phoneInput: {
    searchCountryLabel: 'ابحث عن دولة',
    noMatches: 'لا توجد نتائج',
    phoneRequiredError: 'رقم الهاتف مطلوب',
    phoneNotCorrectError: 'رقم الهاتف غير صحيح'
  },
  orderImage: {
    title: 'صورة الطلب',
    openCameraButton: 'فتح الكاميرا',
    closeCameraButton: 'إغلاق الكاميرا',
    flipCameraButton: 'تبديل الكاميرا',
    downloadLink: 'تحميل',
    cameraNotSupportedError: 'قد لا يدعم المتصفح هذه الميزة أو حدث خطأ ما.',
    imageSavedMessage: 'تم حفظ الصورة'
  },
  logs: {
    cashBackInvoiceTitle: 'فاتورة استرداد نقدي',
    exRateLabel: 'سعر الصرف',
    failedToMergeSelectedInvoices: 'فشل دمج الفواتير المحددة.',
    receiptLabel: 'إيصال',
    creditInvoiceNumber: 'رقم فاتورة الرصيد',
    customerAddress: 'عنوان العميل',
    customerTel: 'هاتف العميل',
    oldAmount: 'المبلغ القديم',
    newAmount: 'المبلغ الجديد',
    totalIqdLabel: 'الإجمالي بالدينار العراقي',
    refundInvoiceTitle: 'فاتورة استرداد',
    shoppingOnlineInvoiceTitle: 'فاتورة تسوق أونلاين',
    orderNumberColon: 'رقم الطلب:',
    itemColumn: 'الصنف',
    refundReasonPrefix: 'استرداد —',
    deliveryPriceColon: 'سعر التوصيل:',
    deliveryColon: 'التوصيل:',
    shipZoneFeeColon: 'رسوم ShipZone:',
    deliveryIraqiPriceColon: 'سعر التوصيل بالدينار العراقي:',
    phoneColon: 'الهاتف:',
    emailColon: 'البريد الإلكتروني:',
    signatureLabel: 'التوقيع: _______________________________',
    orderNoColumn: 'رقم الطلب',
    remainColumn: 'المتبقي',
    subTotalLabel: 'المجموع الفرعي:',
    totalPaidLabel: 'إجمالي المدفوع:',
    totalRemainingLabel: 'إجمالي المتبقي:',
    totalReceivedLabel: 'إجمالي المستلم:',
    totalRemainLabel: 'إجمالي المتبقي:'
  },
  whatsappTemplate: {
    sendWhatsappMessageLabel: 'إرسال رسالة واتساب',
    englishMessageLabel: 'رسالة بالإنجليزية',
    arabicMessageLabel: 'رسالة بالعربية',
    kurdishMessageLabel: 'رسالة بالكردية',
    saveAsDefaultTemplateButton: 'حفظ كقالب افتراضي',
    deliverToBranchTitle: 'التسليم إلى الفرع',
    sendAllToBranchTitle: 'إرسال الكل إلى الفرع',
    templateSavedSuccessfully: 'تم حفظ القالب بنجاح',
    failedToSaveTemplate: 'فشل حفظ القالب'
  },
  orderLog: {
    yourStaffLabel: 'موظفكم',
    yourCustomerLabel: 'عميلكم',
    requestedVerb: 'طلب',
    theOrderConnector: 'الطلب',
    deliveredTheOrderLabel: 'وصّل الطلب',
    toConnector: 'إلى',
    shippedVerb: 'شحن',
    processedVerb: 'عالج',
    canceledVerb: 'ألغى',
    approvedVerb: 'وافق على',
    refundedVerb: 'استرد',
    purchasedVerb: 'اشترى',
    sentToBranchVerb: 'أرسل إلى الفرع',
    atConnector: 'في'
  }
}



// WEBPACK FOOTER //
// ./src/lang/ar.js